/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";

// Kanban Board View
import Board from "react-trello";
import "../Assets/css/style.css";
import Label from "../components/Label";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Grid,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Icon,
  Box,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  FormControl,
  Switch,
  CircularProgress,
  Link,
  CardHeader
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Select from "react-select";
import Page from "../components/Page";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  featchleadhistory,
  fetchallcitylist,
  fetchallocatelistbyid,
  fetchchapterbyuser,
  fetchCityList,
  fetchrenewalmemberdata,
  fetchStateList,
  GetAllMember,
  handleDownload,
  formatExpiryExtension,
  getDefaultExpiryDate
} from "src/utils/common";
import {
  getAttributeListApi,
  deleteLeadAttachment,
  getLeadRejectReason,
  getNewLeadDataForExport,
  getNewLeadList,
  insertLead,
  insertMemberLeadRejectReason,
  insertmember,
  leadTransferTO,
  memberRenewal,
  updateEditModeInMemberRenewalLead,
  updateLeadExpiryApi,
  updateLeadMemberForm,
  updateleadstatus,
  uploadPaymentImage
} from "src/api/commonapi";
import moment from "moment";
import LimitedTextField from "src/components/LimitedTextField";
import { notification } from "src/utils/messages";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import {
  AutoGraphSharp,
  EditSharp,
  LeaderboardSharp,
  PersonAddAltSharp,
  SendSharp,
  ThumbUpAlt,
  Close,
  Person,
  AddPhotoAlternate,
  ChangeCircle,
  Check,
  ReportGmailerrorredOutlined,
  ContentCopy,
  NotificationsActive
} from "@mui/icons-material";
import { Routes } from "src/constant/api_url";
import { getLeadByLid, insertFollowUp } from "../api/commonapi";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import ChapterSelectDropDown from "src/components/ChapterSelectDropDown";
import LeadStatusDescriptionViewModal from "./LeadStatusDescriptionViewModal";
import {
  gender,
  invoiceTypeFilter,
  IsNotValue,
  leadDetailsModelStyle,
  leadFollowupStyle,
  LeadSearchTypeOptions
} from "src/constant/variable";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";
import CustomLaneHeader from "src/components/CustomLaneHeader";
import InvoiceAmountVerifiedModal from "./InvoiceAmountVerifiedModal";
import InvoiceDownloadForm from "./InvoiceDownloadForm";
import { sendInvoiceReminderToMemberApi, updateInvoiceDetailsApi } from "src/api/invoiceApi";

export default function Lead() {
  const loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const [chaptlist, setchaplist] = useState([]);
  const [step, setStep] = useState(0);
  const [formdata, setformdata] = useState({
    l_created_by: loginUser.u_id,
    l_type: 0,
    gender: 0
  });

  const [memberdata, setnewmemberdata] = useState({
    chpt_id: 0,
    joining_date: moment().format("DD-MM-YYYY"),
    due_date: moment().add(1, "years").format("DD-MM-YYYY"),
    type: 0,
    invite_by: 0,
    gender: 0
  });

  const [memberrenewaldata, setmemberrenewaldata] = useState({});

  const [myModal, setMyModal] = useState({
    mval: false,
    lead_id: 0,
    l_phase: 1
  });
  const [statusList, setStatusList] = useState([]);
  const [generateInvoiceModal, setGenerateInvoiceModal] = useState(false);
  const [statusListMap, setStatusListMap] = useState({});
  const [allocatelist, setallocatelist] = useState([]);
  const [leadHistory, setLeadHistory] = useState([]);

  const [filterlead, setfilterlead] = useState({
    u_id: loginUser.u_id,
    u_type: loginUser.u_type,
    filterl: "",
    s_date: null,
    e_date: null,
    filteruser: 0,
    l_phase: location.state?.l_phase ?? -1,
    lead_status: location.state?.lead_status ?? -1,
    lead_type: -1,
    filterCity:
      loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : location.state?.city || 0,
    selected_subadmin: -1,
    parent_user_id: -1,
    invoice_generated_filter: -1
    // user_allocated: 0,
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [filterOption, setFilterOption] = useState([{ value: 0, label: "All Users" }]);

  const [newleadData, setnewLeadData] = useState([]);
  const [followUpModal, setFollowUpModal] = useState(false);
  const [leadStatusDescriptionViewModal, setLeadStatusDescriptionViewModal] = useState(false);
  const [leadStatusData, setLeadStatusData] = useState("");
  const [followUpData, setFollowUpData] = useState({ u_id: loginUser.u_id });
  const [leadtransModal, setLeadTransModal] = useState(false);
  const [paymentimgModal, setpaymentimgModal] = useState(false);
  const [leadtransData, setLeadTransData] = useState({ u_id: loginUser.u_id });
  const [payimgData, setpayimgData] = useState({});
  const [fileimage, setfileimage] = useState();
  const [convertmemberModal, setConvertMemberModal] = useState(false);
  const [memberrenewalmodal, setmemberrenewalmodal] = useState(false);
  const [rejectmemberModal, setrejectmemberModal] = useState(false);
  const [rejectReasonData, setRejectReasonData] = useState({
    l_r_reason_id: 0
  });
  const [rejectReasonlist, setRejectReasonlist] = useState([]);
  const [isFormSubmit, setIsFormSubmit] = useState(false);

  const [boardLoading, setBoardLoading] = useState(false);
  const [memberlist, setmemberlist] = useState([]);
  const [citylist, setcitylist] = useState([]);
  const [allCityList, setAllCityList] = useState([]);
  const [statelist, setstatelist] = useState(null);
  // Tab View
  const [value, setValue] = useState("1");
  const [formLink, setFormLink] = useState("");

  const [expanded, setExpanded] = useState(0);

  const [leadStatusChangeModal, setLeadStatusChangeModal] = useState(false);

  const [leadStatusChangeData, setLeadStatusChangeData] = useState({
    lead_id: 0, // Lead ID
    l_phase: 1, // Updated Lead Status
    u_id: loginUser?.u_id || 0, // User ID
    from_l_phase: 1, // Old Lead Status
    l_type: "",
    l_allocated_to: 0
  });

  const [isLoading, setIsLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingMoreData, setLoadingMoreData] = useState(-1);

  const [newLan, setNewLan] = useState({
    allLeadList: [],
    allLeadIds: [],
    newVistiorInquiryLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    newMemberRenewalLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    confirmedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    waitingForPaymentLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    paymentVerifiedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    giveAppAccessLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    rejectedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    memberDeactivatedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  });

  const [activeTab, setActiveTab] = useState(1);

  const [isLoading_leadConvertMember_Btn, setIsLoading_leadConvertMember_Btn] = useState(false);

  const [editFormConfirmModal, setEditFormConfirmModal] = useState({
    open: false,
    leadId: null,
    currentVal: 0
  });
  const [invoiceAmountVerifiedData, setInvoiceAmountVerifiedData] = useState({});
  const [invoiceAmountVerifiedModal, setInvoiceAmountVerifiedModal] = useState(false);
  const [draggedCardInfo, setDraggedCardInfo] = useState(null);
  const [reminderConfirmModal, setReminderConfirmModal] = useState({
    open: false,
    leadId: null
  });

  const toggleInvoiceAmountVerifiedModal = () =>
    setInvoiceAmountVerifiedModal(!invoiceAmountVerifiedModal);

  const handleInvoiceModalClose = () => {
    // Revert card position by refreshing the board if modal is closed without submit
    if (!invoiceAmountVerifiedData?.isSubmit) {
      getAllPhaseLeads();
    }
    setDraggedCardInfo(null);
    setInvoiceAmountVerifiedData({});
  };

  const submitEditInvoiceDetails = async () => {
    setIsLoading(true);
    const data = {
      lead_id: invoiceAmountVerifiedData.lead_id,
      i_item_id: invoiceAmountVerifiedData.i_item_id,
      invoice_amt: invoiceAmountVerifiedData.i_amount,
      base_i_amount: invoiceAmountVerifiedData.base_i_amount,
      member_id: invoiceAmountVerifiedData.member_id,
      payment_date: moment(invoiceAmountVerifiedData.payment_date, "DD-MM-YYYY").format("DD-MM-YYYY"),
      payment_mode: invoiceAmountVerifiedData.payment_mode,
      invoice_expiry_date: moment(invoiceAmountVerifiedData.invoice_expiry_date, "DD-MM-YYYY").format("DD-MM-YYYY")
    };
    const resp = await updateInvoiceDetailsApi(data);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      if (
        invoiceAmountVerifiedData?.expiry_date &&
        invoiceAmountVerifiedData?.due_date &&
        invoiceAmountVerifiedData.expiry_date != invoiceAmountVerifiedData.due_date
      ) {
        const expiryResp = await updateLeadExpiryApi({
          lead_id: invoiceAmountVerifiedData.lead_id,
          member_id: invoiceAmountVerifiedData.member_id,
          joining_date: invoiceAmountVerifiedData.joining_date,
          due_date: moment(invoiceAmountVerifiedData.expiry_date, "DD-MM-YYYY").format(
            "DD-MM-YYYY"
          ),
          previous_due_date: invoiceAmountVerifiedData.previous_due_date,
          changed_by: loginUser?.u_id,
          changed_by_type: loginUser?.u_type
        });
        let expiryNotify = notification({
          type: expiryResp.status == 0 ? "error" : "success",
          message: expiryResp.message
        });
        expiryNotify();
      }
      setLeadHistory(await featchleadhistory(invoiceAmountVerifiedData.lead_id));
      setInvoiceAmountVerifiedData({});
    }
  };

  const submitExpiryEdit = async () => {
    setIsLoading(true);
    const data = {
      lead_id: invoiceAmountVerifiedData.lead_id,
      member_id: invoiceAmountVerifiedData.member_id,
      joining_date: invoiceAmountVerifiedData.joining_date,
      due_date: moment(invoiceAmountVerifiedData.expiry_date, "DD-MM-YYYY").format("DD-MM-YYYY"),
      previous_due_date: invoiceAmountVerifiedData.previous_due_date,
      changed_by: loginUser?.u_id,
      changed_by_type: loginUser?.u_type
    };
    const resp = await updateLeadExpiryApi(data);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setLeadHistory(await featchleadhistory(invoiceAmountVerifiedData.lead_id));
      setInvoiceAmountVerifiedData({});
    }
  };

  const closeLeadStatusChangeModal = () => {
    setLeadStatusChangeModal(false);
    setLeadStatusChangeData({
      lead_id: 0, // Lead ID
      l_phase: 1, // Updated Lead Status
      u_id: loginUser?.u_id || 0, // User ID
      from_l_phase: 1, // Old Lead Status
      l_type: "",
      l_allocated_to: 0
    });
  };

  const handleGetAttributeList = async () => {
    const resp = await getAttributeListApi();
    if (resp.status == 1) {
      const filteredAttributesList = resp.data?.filter((item) => item.a_id != 3 && item.a_id != 9);
      setStatusList(filteredAttributesList);
      setStatusListMap(
        Object.fromEntries(filteredAttributesList?.map(({ a_id, name }) => [a_id, name]))
      );
    }
  };

  const confirmModalstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };

  const getallcitylist = async () => {
    setAllCityList(await fetchallcitylist());
  };

  const initNewLan = {
    allLeadList: [],
    allLeadIds: [],
    newVistiorInquiryLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    newMemberRenewalLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    confirmedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    waitingForPaymentLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    paymentVerifiedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    giveAppAccessLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    rejectedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    memberDeactivatedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  };

  const getAllPhaseLeads = async (newState = false) => {
    setBoardLoading(true);
    const filteruser =
      loginUser?.u_type == 1 && loginUser?.is_subadmin == 1
        ? newState
          ? newState.filteruser == loginUser?.u_id
            ? 0
            : newState.filteruser
          : filterlead.filteruser == loginUser?.u_id
            ? 0
            : filterlead.filteruser
        : newState
          ? newState.filteruser
          : filterlead.filteruser;
    const currentFilter = newState ? newState : filterlead;
    const isInvoiceFilterApplied = currentFilter.invoice_generated_filter !== -1;

    const [
      newVistiorInquiryLead,
      newMemberRenewalLead,
      confirmedLead,
      waitingForPaymentLead,
      paymentVerifiedLead,
      giveAppAccessLead,
      rejectedLead,
      memberDeactivatedLead
    ] = await Promise.all([
      // New Visitor / Inquiry Lead
      !isInvoiceFilterApplied
        ? getNewLeadList({
          ...currentFilter,
          filteruser,
          l_phase: 1,
          id_array: []
        })
        : Promise.resolve({ status: 0 }),
      // New Member Renewal Lead
      !isInvoiceFilterApplied
        ? getNewLeadList({
          ...currentFilter,
          filteruser,
          l_phase: 2,
          id_array: []
        })
        : Promise.resolve({ status: 0 }),
      // Confirm Lead
      !isInvoiceFilterApplied
        ? getNewLeadList({
          ...currentFilter,
          filteruser,
          l_phase: 4,
          id_array: []
        })
        : Promise.resolve({ status: 0 }),
      // Waiting For Payment
      !isInvoiceFilterApplied
        ? getNewLeadList({
          ...currentFilter,
          filteruser,
          l_phase: 5,
          id_array: []
        })
        : Promise.resolve({ status: 0 }),
      // paymentVerifiedLead
      getNewLeadList({
        ...currentFilter,
        filteruser,
        l_phase: 6,
        id_array: []
      }),
      // giveAppAccessLead
      getNewLeadList({
        ...currentFilter,
        filteruser,
        l_phase: 7,
        id_array: []
      }),
      // rejectedLead
      !isInvoiceFilterApplied
        ? getNewLeadList({
          ...currentFilter,
          filteruser,
          l_phase: 8,
          id_array: []
        })
        : Promise.resolve({ status: 0 }),
      // memberDeactivatedLead
      !isInvoiceFilterApplied
        ? getNewLeadList({
          ...currentFilter,
          filteruser,
          l_phase: 10,
          id_array: []
        })
        : Promise.resolve({ status: 0 })
    ]);

    setBoardLoading(false);

    if (newVistiorInquiryLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, newVistiorInquiryLead, "newVistiorInquiryLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
    if (newMemberRenewalLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, newMemberRenewalLead, "newMemberRenewalLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
    if (confirmedLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, confirmedLead, "confirmedLead"));
    } else {
      setNewLan((prevState) => prevState);
    }

    if (waitingForPaymentLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, waitingForPaymentLead, "waitingForPaymentLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }

    if (paymentVerifiedLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, paymentVerifiedLead, "paymentVerifiedLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }

    if (giveAppAccessLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, giveAppAccessLead, "giveAppAccessLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }

    if (rejectedLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, rejectedLead, "rejectedLead"));
    } else {
      setNewLan((prevState) => prevState);
    }

    if (memberDeactivatedLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, memberDeactivatedLead, "memberDeactivatedLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
  };

  const getFilterLeadData = async () => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      newVistiorInquiryLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      newMemberRenewalLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      confirmedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      waitingForPaymentLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      paymentVerifiedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      giveAppAccessLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      rejectedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      memberDeactivatedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });

    if (filterlead.lead_status != -1) {
      // go for Specific lead Status
      await handleCustomLaneScroll(filterlead.lead_status, true);
    } else {
      // get All Lead
      await getAllPhaseLeads();
    }
  };
  const genderLabel = ["Not Selected", "Male", "Female"];

  const exportFilteredLead = async (event, done) => {
    setLoading(true);
    setIsLoading(true);
    let resp = await getNewLeadDataForExport({
      ...filterlead,
      type: 0
    });
    setIsLoading(false);

    if (resp.status == 1) {
      // return resp.data;
      downloadCSV(resp.data);
    } else {
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
    setLoading(false);
  };

  const downloadCSV = (data) => {
    const csvContent =
      `${expo_columns?.map((column) => column.label).join(",")}\n` +
      `${data
        ?.map((row) =>
          expo_columns
            ?.map((column) => {
              // Convert value to string
              // const value = (row[column.key] || "").toString();
              let value =
                row[column.key] == undefined ||
                  row[column.key] === null ||
                  row[column.key] === "null"
                  ? ""
                  : row[column.key].toString();

              // Special handling for the Followup column
              if (column.key == "follow_ups") {
                // Replace comma with newline for wrap effect
                value = value.replace(/, /g, "\r\n").trim();
              } else if (column.key == "gender") {
                value = genderLabel[Number(value)];
              }

              return `"${value.replace(/"/g, '""')}"`; // Escape double quotes and enclose in quotes
            })
            .join(",")
        )
        .join("\n")}`;

    // Create Blob from CSV content
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    // Create URL for the Blob
    const blobUrl = window.URL.createObjectURL(blob);

    // Create anchor element
    const link = document.createElement("a");
    link.setAttribute("href", blobUrl);
    link.setAttribute("download", "LeadList.csv");

    // Append anchor element to the body and trigger click event
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  };

  const resetSearchForm = async (newState) => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      newVistiorInquiryLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      newMemberRenewalLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      confirmedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      waitingForPaymentLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      paymentVerifiedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      giveAppAccessLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      rejectedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      memberDeactivatedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });

    await getAllPhaseLeads(newState);
  };

  const updateAPIDataToState = (prevState, newResponse, lead_key) => {
    const { leadList } = newResponse.data;
    const { counter } = newResponse.data;

    const appendedCards = setDataInCard(leadList);
    // Merge with uniqueness by lead_id
    const existingById = new Map(prevState["allLeadList"].map((item) => [item.id, item]));
    for (const card of appendedCards) {
      existingById.set(card.id, card);
    }
    const mergedAllLeadList = Array.from(existingById.values());

    const mergedAllLeadIds = Array.from(
      new Set([...prevState["allLeadIds"], ...leadList?.map((lead) => lead?.lead_id)])
    );

    const mergedLaneIds = Array.from(
      new Set([...prevState[lead_key].id_array, ...leadList?.map((lead) => lead.lead_id)])
    );

    return {
      ...prevState,
      ["allLeadList"]: mergedAllLeadList,
      ["allLeadIds"]: mergedAllLeadIds,
      [lead_key]: {
        ...prevState[lead_key],
        counter: counter,
        // leadList: [...prevState[lead_key].leadList, ...setDataInCard(leadList)],
        id_array: mergedLaneIds,
        is_no_more: leadList.length < 20 ? true : false
      }
    };
  };

  const setDataInCard = (list) => {
    return list.map((e, key) => {
      return {
        id: e.lead_id,
        l_type: e.l_type,
        taskTitle: e.name,
        referenceBy: e.reference_by != null ? e.reference_by : "No Ref",
        createdDate: moment(e.created_at).format("DD-MM-YYYY hh:mm A"),
        updatedDate: moment(e.updated_at).format("DD-MM-YYYY hh:mm A"),
        body: e.name,
        contactNo: e.l_contact_no,
        taskCreatedPerson: e.createdBy,
        metadata: { id: e.lead_id },
        person: e.allocatedTo,
        phase: e.l_phase,
        tags: {
          cardId: e.lead_id,
          priority_Id: e.l_type,
          attendance_status: e.attendance_status,
          title:
            e.l_type == 0
              ? "Other"
              : e.l_type == 1
                ? e.attendance_status == 0
                  ? "Visitor Present"
                  : "Visitor Absent"
                : e.l_type == 2
                  ? "Member Renewal"
                  : e.l_type == 3
                    ? "Confirm Member"
                    : ""
        },
        expireDate: e.l_type == 2 && e.Due_date,
        chepter_name: e.chepter_name,
        lastElement: key == list.length - 1 ? true : false,
        is_edit_form: e.is_edit_form,
        l_allocated_to: e.l_allocated_to,
        payment_mode: e.payment_mode,
        payment_date: e.payment_date,
        invoice_amt: e.invoice_amt,
        i_item_id: e.i_item_id,
        invoice_expiry_date: e.invoice_expiry_date,
        last_i_id: e.last_i_id
      };
    });
  };

  const handleCustomLaneScroll = async (laneId, isCallFromSearch = false) => {
    const lead_key =
      laneId == 1
        ? "newVistiorInquiryLead"
        : laneId == 2
          ? "newMemberRenewalLead"
          : laneId == 4
            ? "confirmedLead"
            : laneId == 5
              ? "waitingForPaymentLead"
              : laneId == 6
                ? "paymentVerifiedLead"
                : laneId == 7
                  ? "giveAppAccessLead"
                  : laneId == 8
                    ? "rejectedLead"
                    : laneId == 10
                      ? "memberDeactivatedLead"
                      : "";

    if (isCallFromSearch || newLan[lead_key].is_no_more !== true) {
      // if (filterlead.invoice_generated_filter !== -1 && laneId !== 6 && laneId !== 7) {
      //   setLoadingMoreData(-1);
      //   return;
      // }
      if (loadingMoreData != laneId) {
        setLoadingMoreData(laneId);
        let resp = await getNewLeadList({
          ...filterlead,
          l_phase: laneId,
          id_array: isCallFromSearch ? [] : newLan["allLeadIds"]
        });

        if (resp.status == 1) {
          let newDataList = resp.data.leadList;
          let counter = resp.data.counter;
          setNewLan((prevState) => {
            const appendedCards = setDataInCard(newDataList);
            const existingById = new Map(prevState["allLeadList"].map((item) => [item.id, item]));
            for (const card of appendedCards) {
              existingById.set(card.id, card);
            }
            const mergedAllLeadList = Array.from(existingById.values());

            const mergedAllLeadIds = Array.from(
              new Set([...prevState["allLeadIds"], ...newDataList?.map((lead) => lead?.lead_id)])
            );

            const mergedLaneIds = Array.from(
              new Set([
                ...prevState[lead_key].id_array,
                ...newDataList?.map((lead) => lead.lead_id)
              ])
            );

            return {
              ...prevState,
              ["allLeadList"]: mergedAllLeadList,
              ["allLeadIds"]: mergedAllLeadIds,
              [lead_key]: {
                ...prevState[lead_key],
                // leadList: [...prevState[lead_key].leadList, ...setDataInCard(newDataList)],
                counter: counter,
                id_array: mergedLaneIds,
                is_no_more: newDataList.length < 20 ? true : false
              }
            };
          });
          setLoadingMoreData(-1);
        } else {
          setNewLan((prevState) => prevState);
          setLoadingMoreData(-1);
        }
      }
      setLoadingMoreData(-1);
    }
    setLoadingMoreData(-1);
  };

  const getallocatelistbyid = async () => {
    if (loginUser.u_type == 2) {
      setallocatelist(await fetchallocatelistbyid(loginUser.p_user_id, loginUser.u_type));
    } else {
      setallocatelist(await fetchallocatelistbyid(loginUser.u_id, loginUser.u_type));
    }
  };

  const onChangeFunction = (e) => {
    setformdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const getLeadByLeadId = async (l_id) => {
    let res = await getLeadByLid(l_id);
    let arr = [];
    if (res.insuranceType != "") {
      arr = res.insuranceType.split(",");
    }
    setformdata({ ...res, insuranceType: arr });
  };

  const submitformdata = async () => {
    setIsLoading(true);
    let fdata = new FormData();
    Object.keys(formdata)?.map((key) => {
      if (key === "l_payment_photo") {
        // Append multiple payment photos
        if (Array.isArray(formdata[key]) && formdata[key].length > 0) {
          formdata[key].forEach((file, index) => {
            fdata.append(`l_payment_photo`, file);
          });
        }
      } else {
        fdata.append(key, key == "insuranceType" ? formdata[key].join(",") : formdata[key]);
      }
    });

    if (
      formdata.l_allocated_to == undefined ||
      formdata.l_phase == undefined ||
      // (step == 1 && (formdata.gender == undefined || formdata.gender == 0)) ||
      formdata.name == undefined ||
      formdata.name == "" ||
      formdata.l_business_name == undefined ||
      formdata.l_business_name == "" ||
      formdata.l_contact_no == undefined ||
      formdata.l_contact_no == "" ||
      formdata.l_business_category == undefined ||
      formdata.l_business_category == "" ||
      formdata.date == undefined ||
      formdata.date == ""
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
      setIsLoading(false);
    } else {
      let resp;
      if (step == 1) {
        if (loginUser.u_id == formdata?.u_allocated && loginUser.u_type == 1) {
          fdata.append("p_u_id", loginUser?.p_user_id);
        } else if (loginUser.u_type == 2 || loginUser.u_type == 1) {
          fdata.append("p_u_id", loginUser?.p_user_id);
        } else {
          if (loginUser.u_type == 0 && loginUser.is_subadmin == 1)
            fdata.append("p_u_id", loginUser?.p_user_id);
          else fdata.append("p_u_id", loginUser?.u_id);
        }
        // if (loginUser.u_type != 0) {
        //   fdata.append("p_u_id", loginUser?.p_user_id);
        // } else {
        //   fdata.append("p_u_id", loginUser?.u_id);
        // }
        resp = await insertLead(fdata);
      } else if (step == 2) {
        fdata.append("u_id", loginUser?.u_id);
        fdata.append("edit_from_panel", 0);
        // updateLeadMemberForm()
        // resp = await updateleaddetails(fdata);
        resp = await updateLeadMemberForm(fdata);
      }
      if (resp.status == 1) {
        setStep(0);
        setActiveTab(1);
        setformdata({ l_created_by: loginUser.u_id, l_type: 0, gender: 0 });

        // Visitor / Inquiry Lead API CALL
        setNewLan(initNewLan);
        await getAllPhaseLeads();
        // getleadlist();
      }
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      setIsLoading(false);
    }
  };

  const submitfollowup = async () => {
    setIsLoading(true);
    const resp = await insertFollowUp(JSON.stringify(followUpData));
    setIsLoading(false);
    if (resp.status == 1) {
      setFollowUpModal(false);
      setFollowUpData({ u_id: loginUser.u_id });
      setLeadHistory(await featchleadhistory(myModal.lead_id));
      setMyModal(false);
      setNewLan(initNewLan);
      await getAllPhaseLeads();
    }
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const submitleadtransfer = async () => {
    setIsLoading(true);
    const resp = await leadTransferTO(JSON.stringify(leadtransData));
    setIsLoading(false);
    if (resp.status == 1) {
      setLeadTransModal(false);
      setLeadTransData({ u_id: loginUser.u_id });
      setLeadHistory(await featchleadhistory(myModal.lead_id));
      // Visitor / Inquiry Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
      // getleadlist();
    }
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const submitleadrejectreason = async () => {
    setIsFormSubmit(true);
    if (
      rejectReasonData.l_r_reason_id == 0 ||
      rejectReasonData.l_r_reason_id == "" ||
      rejectReasonData.l_r_reason_id == null ||
      rejectReasonData.l_r_reason_id == undefined
    ) {
      let notify = notification({
        type: "error",
        message: "Please enter all required fields to submit"
      });
      notify();
      setIsFormSubmit(false);
    } else {
      setIsLoading(true);
      let resp = await insertMemberLeadRejectReason(JSON.stringify(rejectReasonData));
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      setIsFormSubmit(false);
      notify();
      if (resp.status == 1) {
        let lfdata = new FormData();
        lfdata.append("lead_id", rejectReasonData.cardId);
        lfdata.append("l_phase", rejectReasonData.targetLaneId);
        lfdata.append("u_id", loginUser.u_id);
        lfdata.append("from_l_phase", rejectReasonData.sourceLaneId);

        setIsLoading(true);
        const resp = await updateleadstatus(lfdata);
        setIsLoading(false);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          setIsFormSubmit(false);
          setrejectmemberModal(false);
          setLeadStatusChangeModal(false);
          setRejectReasonData({
            l_r_reason_id: 0
          });
          // await getleadlist();
          // Visitor / Inquiry Lead API CALL
          setNewLan(initNewLan);
          await getAllPhaseLeads();
        }
      }
    }
  };

  const submitmemberrenewal = async () => {
    setIsLoading(true);
    let resp = await memberRenewal(JSON.stringify(memberrenewaldata));
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      let lfdata = new FormData();
      lfdata.append("lead_id", memberrenewaldata.cardId);
      lfdata.append("l_phase", memberrenewaldata.targetLaneId);
      lfdata.append("u_id", loginUser.u_id);
      lfdata.append("from_l_phase", memberrenewaldata.sourceLaneId);

      setIsLoading(true);
      const resp = await updateleadstatus(lfdata);
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        setmemberrenewalmodal(false);
        setLeadStatusChangeModal(false);

        const memberresp = await fetchrenewalmemberdata(memberrenewaldata.cardId);

        const originalDue = moment(memberresp.due_date, "DD-MM-YYYY");
        const currentYear = moment().year();
        const adjustedDue = originalDue.clone().year(currentYear);
        const renewedDue = adjustedDue.clone().add(1, "year");
        const minDate = adjustedDue.clone().subtract(1, "month").add(1, "day");
        const maxDate = renewedDue.clone();

        setmemberrenewaldata({
          ...memberresp,
          actual_due_date: memberresp.due_date,
          newdue_date: renewedDue.format("DD-MM-YYYY"),
          cardId: memberrenewaldata.cardId,
          targetLaneId: memberrenewaldata.targetLaneId,
          sourceLaneId: memberrenewaldata.sourceLaneId,
          minDate: minDate.toDate(),
          maxDate: maxDate.toDate()
        });
        // await getleadlist();
        // Visitor / Inquiry Lead API CALL
        setNewLan(initNewLan);
        await getAllPhaseLeads();
      }
    }
    // if (resp.status == 1) {
    //   setmemberrenewalmodal(false);
    //   setmemberrenewaldata({ newdue_date: moment().add(1, "years").format("DD-MM-YYYY") });
    //   await getleadlist();
    // }
  };

  const leadStatusChange = async (cardId, targetLaneId, sourceLaneId) => {
    let resp = await featchleadhistory(cardId);
    const lead = resp?.leaddetails;

    // Prevent same-lane movement
    if (targetLaneId === sourceLaneId) return;

    // 🚫 Don't allow Member Renewal lead to go to Visitor/Inquiry
    if (lead.l_type == 2 && targetLaneId == 1) {
      let notify = notification({
        type: "error",
        message: `You cannot move a ${statusListMap[2]} to ${statusListMap[targetLaneId]}`
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    if (
      (lead.l_phase != 2 && targetLaneId == 10) ||
      (lead.l_phase == 7 && targetLaneId < 8) ||
      (lead.l_phase == 5 && targetLaneId != 6 && targetLaneId != 8) ||
      (lead.l_phase == 6 && targetLaneId < 7)
    ) {
      let notify = notification({
        type: "error",
        message: `You cannot move a ${statusListMap[lead.l_phase]} lead to ${statusListMap[targetLaneId]}`
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    // 🚫 Don't allow Visitor/Inquiry lead to go to Member Renewal
    if ((lead.l_type == 0 || lead.l_type == 1) && targetLaneId == 2) {
      let notify = notification({
        type: "error",
        message: `You cannot move a ${statusListMap[1]} to ${statusListMap[targetLaneId]}`
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    if (
      // 🚫 Role-based restrictions: not allowed to move out of some lanes
      (((sourceLaneId == 5 &&
        ((loginUser.p_user_id != 1 && loginUser.u_type == 2) ||
          (loginUser.u_type == 1) ||
          (loginUser.p_user_id == 1 &&
            loginUser.u_type == 2 &&
            loginUser.management_p == 0 &&
            loginUser.account_p == 0))) ||
        ((sourceLaneId == 6 || sourceLaneId == 7) &&
          loginUser.u_type == 2 &&
          loginUser.management_p == 0 &&
          loginUser.account_p == 0)) &&
        loginUser.u_type != 0) ||
      // 🚫 Role-based restrictions: not allowed to move into of some lanes
      (((targetLaneId == 6 &&
        ((loginUser.p_user_id != 1 && loginUser.u_type == 2) ||
          (loginUser.u_type == 1) ||
          (loginUser.p_user_id == 1 &&
            loginUser.u_type == 2 &&
            loginUser.management_p == 0 &&
            loginUser.account_p == 0))) ||
        (targetLaneId == 7 && loginUser.u_type == 2 && loginUser.management_p == 0)) &&
        loginUser.u_type != 0)
    ) {
      closeLeadStatusChangeModal();
      let notify = notification({
        type: "error",
        message: "You don't have Permission "
      });
      notify();
      // await getleadlist();
      // New Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
      return;
    }

    // ✅ Move to New Member or Renewal
    if (
      targetLaneId == 7 &&
      sourceLaneId == 6 &&
      (loginUser?.u_type == 0 ||
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.management_p == 1))
    ) {
      setnewmemberdata({
        chpt_id: 0,
        joining_date: moment().format("DD-MM-YYYY"),
        due_date: moment().add(1, "years").format("DD-MM-YYYY"),
        type: 0,
        invite_by: 0,
        gender: 0
      });

      if (lead.l_type == 2) {
        let memberresp = await fetchrenewalmemberdata(cardId);

        const originalDue = moment(memberresp.due_date, "DD-MM-YYYY"); // actual DB due date
        const currentYear = moment().year();
        const adjustedDue = originalDue.clone().year(currentYear); // set to current year
        const renewedDue = adjustedDue.clone().add(1, "year"); // new due date for renewal
        const minDate = adjustedDue.clone().subtract(1, "month").add(1, "day"); // e.g., 17-06-2025
        const maxDate = renewedDue.clone(); // e.g., 16-07-2026

        setmemberrenewaldata({
          ...memberrenewaldata,
          ...memberresp,
          actual_due_date: memberresp.due_date, // store original
          newdue_date: renewedDue.format("DD-MM-YYYY"), // suggested new due date
          cardId: cardId,
          targetLaneId: targetLaneId,
          sourceLaneId: sourceLaneId,
          minDate: minDate.toDate(),
          maxDate: maxDate.toDate()
        });
        setmemberrenewalmodal(true);
      } else {
        setConvertMemberModal(true);
        setnewmemberdata({
          ...memberdata,
          ...lead,
          joining_date: lead.joining_date && moment(lead.joining_date, "DD-MM-YYYY").isValid()
            ? moment(lead.joining_date, "DD-MM-YYYY").format("DD-MM-YYYY")
            : moment(lead.payment_date, "DD-MM-YYYY").format("DD-MM-YYYY"),
          due_date:
            lead?.due_date && moment(lead.due_date, "DD-MM-YYYY").isValid()
              ? moment(lead.due_date, "DD-MM-YYYY").format("DD-MM-YYYY")
              : (lead?.payment_date || lead?.joining_date)
                ? moment(lead?.payment_date || lead?.joining_date, "DD-MM-YYYY")
                  .add(1, "years")
                  .format("DD-MM-YYYY")
                : moment().add(1, "years").format("DD-MM-YYYY"),
          admin_limit_date:
            (lead?.admin_limit_date || lead?.due_date || lead?.Due_date) &&
              moment(
                lead?.admin_limit_date || lead?.due_date || lead?.Due_date,
                "DD-MM-YYYY"
              ).isValid()
              ? moment(
                lead?.admin_limit_date || lead?.due_date || lead?.Due_date,
                "DD-MM-YYYY"
              ).format("DD-MM-YYYY")
              : null,
          cardId: cardId,
          targetLaneId: targetLaneId,
          sourceLaneId: sourceLaneId,
          member_type: lead.l_type == 2 ? 1 : 0
        });
      }

      // New Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
      // await getleadlist();
      return;
    }

    // ✅ Rejected status handling
    if (
      targetLaneId == 8 &&
      (loginUser?.u_type == 0 ||
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.management_p == 1))
    ) {
      setRejectReasonData({
        ...rejectReasonData,
        ...lead,
        cardId: cardId,
        targetLaneId: targetLaneId,
        sourceLaneId: sourceLaneId
      });
      setrejectmemberModal(true);

      // Visitor / Inquiry Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
      // await getleadlist();
      return;
    }

    // 🚫 Move to Payment stage not allowed directly unless from Waiting
    if (targetLaneId == 7 && sourceLaneId != 6 && sourceLaneId != 10) {
      let notify = notification({
        type: "error",
        message: `Please Move Lead to ${statusListMap[5]} stage First`
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    // ✅ Default status update
    let lfdata = new FormData();
    lfdata.append("lead_id", cardId);
    lfdata.append("l_phase", targetLaneId);
    lfdata.append("u_id", loginUser.u_id);
    lfdata.append("from_l_phase", sourceLaneId);
    lfdata.append("l_contact_no", lead.l_contact_no);
    lfdata.append("m_name", lead.name);
    lfdata.append("member_id", lead.member_id);
    if (targetLaneId == 6) {
      lfdata.append("invoice_amt", invoiceAmountVerifiedData.i_amount);
      lfdata.append("base_i_amount", invoiceAmountVerifiedData.base_i_amount);
      lfdata.append("m_email_id", lead.l_email);
      lfdata.append(
        "payment_date",
        moment(invoiceAmountVerifiedData.payment_date, "DD-MM-YYYY").format("DD-MM-YYYY")
      );
      lfdata.append("payment_mode", invoiceAmountVerifiedData.payment_mode);
      lfdata.append("i_item_id", invoiceAmountVerifiedData.i_item_id);
      lfdata.append(
        "invoice_expiry_date",
        moment(invoiceAmountVerifiedData.invoice_expiry_date, "DD-MM-YYYY").format("DD-MM-YYYY")
      );
      lfdata.append(
        "joining_date",
        ((invoiceAmountVerifiedData?.is_renewal
          ? invoiceAmountVerifiedData?.membership_expiry_date
          : invoiceAmountVerifiedData?.joining_date) || moment(invoiceAmountVerifiedData.payment_date, "DD-MM-YYYY").format("DD-MM-YYYY") || moment().format("DD-MM-YYYY"))
      );
      lfdata.append(
        "due_date",
        invoiceAmountVerifiedData?.expiry_date
          ? moment(invoiceAmountVerifiedData.expiry_date, "DD-MM-YYYY").format("DD-MM-YYYY")
          : invoiceAmountVerifiedData?.due_date || ""
      );
      invoiceAmountVerifiedData?.is_renewal &&
        lfdata.append("membership_expiry_date", invoiceAmountVerifiedData?.membership_expiry_date);
      invoiceAmountVerifiedData?.is_renewal &&
        lfdata.append("base_due_date", moment(invoiceAmountVerifiedData?.membership_expiry_date, "DD-MM-YYYY").add(1, "years").format("DD-MM-YYYY"));
    }

    const updateResp = await updateleadstatus(lfdata);
    let notify = notification({
      type: updateResp.status == 0 ? "error" : "success",
      message: updateResp.message
    });
    notify();
    if (updateResp.status == 1) {
      // New Lead API CALL
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      // await getleadlist();
    }
  };

  // KanBan Board
  const len = [[], [], [], [], [], [], [], [], [], []];
  newleadData?.map((e, key) => {
    let temp = {
      id: e.lead_id,
      l_type: e.l_type,
      taskTitle: e.name,
      referenceBy: e.reference_by != null ? e.reference_by : "No Ref",
      createdDate: moment(e.created_at).format("DD-MM-YYYY hh:mm A"),
      updatedDate: moment(e.updated_at).format("DD-MM-YYYY hh:mm A"),
      body: e.name,
      contactNo: e.l_contact_no,
      taskCreatedPerson: e.createdBy,
      metadata: { id: e.lead_id },
      person: e.allocatedTo,
      phase: e.l_phase,
      tags: {
        cardId: e.lead_id,
        priority_Id: e.l_type,
        attendance_status: e.attendance_status,
        title:
          e.l_type == 0
            ? "Other"
            : e.l_type == 1
              ? e.attendance_status == 0
                ? "Visitor Present"
                : "Visitor Absent"
              : e.l_type == 2
                ? "Member Renewal"
                : e.l_type == 3
                  ? "Confirm Member"
                  : ""
      },
      expireDate: e.l_type == 2 && e.Due_date,
      chepter_name: e.chepter_name
    };
    // In Complete And  Rejected Lead Status Set to display on 30 Record on it
    len[e.l_phase].push(temp);
  });

  const getLaneClass = (statusId) => {
    // if ([4].includes(statusId)) return "taskListColumn inReviewTask";
    // if ([5, 6, 7].includes(statusId)) return "taskListColumn finishTask";
    if ([8].includes(statusId)) return "taskListColumn rejectedTask";
    return "taskListColumn openTask";
  };

  const leadList = {
    lanes: statusList.map((status) => {
      const cards = newLan.allLeadList.filter((item) => item.phase === status.a_id);
      const counter =
        status.a_id == 1
          ? newLan.newVistiorInquiryLead.counter
          : status.a_id == 2
            ? newLan.newMemberRenewalLead.counter
            : status.a_id == 4
              ? newLan.confirmedLead.counter
              : status.a_id == 5
                ? newLan.waitingForPaymentLead.counter
                : status.a_id == 6
                  ? newLan.paymentVerifiedLead.counter
                  : status.a_id == 7
                    ? newLan.giveAppAccessLead.counter
                    : status.a_id == 10
                      ? newLan.memberDeactivatedLead.counter
                      : newLan.rejectedLead.counter;

      return {
        id: String(status.a_id),
        title: status.name,
        description: status.description,
        className: getLaneClass(status.a_id), // optional
        cards,
        label: String(counter),
        currentPage: 1,
        style: {
          position: "relative",
          height: `${counter > 0 ? "calc(100vh - 150px)" : ""}`,
          overflowY: "auto"
        }
      };
    })
  };

  const CustomCard = ({
    onClick,
    taskTitle,
    body,
    contactNo,
    createdDate,
    updatedDate,
    subTitle,
    taskCreatedPerson,
    tags,
    showDeleteButton,
    onDelete,
    person,
    phase,
    referenceBy,
    l_type,
    id,
    expireDate,
    chepter_name,
    lastElement,
    is_edit_form,
    l_allocated_to,
    last_i_id
  }) => {
    const clickDelete = (e) => {
      onDelete();
      e.stopPropagation();
    };

    const handleRightClick = (e) => { };

    return (
      <>
        <div
          id={id}
          phase={phase}
          l_type={l_type}
          className="myCard"
          style={{ position: "relative" }}
        >
          <div className="taskCard" style={{ position: "relative" }}>
            <div>
              <header
                className="taskHeader"
                style={{ paddingBottom: "8px" }}
                onClick={() => {
                  setLeadStatusChangeData({
                    ...leadStatusChangeData,
                    lead_id: id,
                    l_type: l_type,
                    from_l_phase: phase,
                    l_allocated_to: l_allocated_to
                  });
                  setLeadStatusChangeModal(true);
                  // setDvisible({ mval: true, id: id });
                }}
              >
                <div className="TaskTitle" style={{ paddingRight: "65px" }}>{taskTitle}</div>
                <Stack direction="row" spacing={1} style={{ position: "absolute", right: "0px", zIndex: "1" }}>
                  {
                    (loginUser?.u_type == 0 ||
                      (loginUser?.u_type == 2 && loginUser?.management_p == 1)) && last_i_id == 0 && (phase == 6 || phase == 7) && (
                      <Tooltip title="Invoice Generate Reminder">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setReminderConfirmModal({ open: true, leadId: id });
                          }}
                        >
                          <NotificationsActive sx={{ color: "#ffc107" }} style={{ height: "20px", width: "20px" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  <Tooltip title="Change Lead Status" style={{ margin: 0 }}>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLeadStatusChangeData({
                          ...leadStatusChangeData,
                          lead_id: id,
                          l_type: l_type,
                          from_l_phase: phase,
                          l_allocated_to: l_allocated_to
                        });
                        setLeadStatusChangeModal(true);
                      }}
                    >
                      <ChangeCircle color="success" style={{ height: "20px", width: "20px" }} />
                    </IconButton>
                  </Tooltip>
                </Stack>
                {showDeleteButton && <div onClick={clickDelete} />}
              </header>
              <div className="taskBody" onContextMenu={handleRightClick} onClick={onClick}>
                {/* <div>{subTitle}</div> */}
                <p>
                  <b>Name : </b> {taskTitle}
                </p>
                <p>
                  <b>Contact : </b> {contactNo}
                </p>
                {l_type !== 0 && !(l_type === 1 && phase === 6) && (
                  <p>
                    <b>Chapter : </b> {chepter_name}
                  </p>
                )}
                {l_type == 2 && (
                  <p>
                    <b>Membership Expire : </b> {expireDate}
                  </p>
                )}
                <p>
                  {l_type != 0 && referenceBy != "null" && (
                    <>
                      <b>Ref : </b> {referenceBy}
                    </>
                  )}
                </p>
              </div>
              <div className="taskUserDetail">
                <div className="taskCreatedName">
                  <b>Assign To : {person}</b>
                </div>
                {createdDate != updatedDate && (
                  <div className="taskDate">
                    <p>
                      <b>Last Update :</b>{" "}
                      <span
                        style={{
                          padding: "2px 5px",
                          background: "#d4edda",
                          color: "#155724",
                          borderRadius: "5px"
                        }}
                      >
                        {updatedDate}
                      </span>
                    </p>
                  </div>
                )}
                <div className="taskDate">
                  <p>
                    <b>Insert Date :</b> {createdDate}
                  </p>
                </div>
                {l_type == 2 && phase === 2 && (
                  <div className="taskDate">
                    <p>
                      <b>Form Update:&nbsp;&nbsp;</b>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={is_edit_form === 1}
                            onChange={() => handleSwitchChange(id)}
                          />
                        }
                        label=""
                      />
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="taskFooter">
              <div>
                <p style={{ fontSize: "15px", fontWeight: "bold" }}>{taskCreatedPerson}</p>
              </div>
              <div>
                <a
                  key={tags.title}
                  {...tags}
                  className="taskPriority"
                  attendance_status={tags.attendance_status}
                // onClick={() => {
                //   alert("hii");
                // }}
                >
                  {tags.title}
                </a>
              </div>
            </div>
          </div>
        </div>

        {loadingMoreData == phase && lastElement ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CircularProgress color="primary" fourColor variant="indeterminate" />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const cancelModal = () => {
    setMyModal({ mval: false, lead_id: 0, l_phase: 1 });
    setFollowUpModal(false);
    setLeadTransModal(false);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const paymentimg = async () => {
    let fndata = new FormData();
    if (payimgData.img == undefined || payimgData?.img?.length == 0) {
      let notify = notification({
        type: "error",
        message: "Please Upload Payment Image"
      });
      notify();
      return;
    }
    payimgData.img.forEach((file) => {
      fndata.append("l_payment_ss", file);
    });
    // fndata.append("l_payment_ss", payimgData.img);
    fndata.append("lead_id", myModal.lead_id);
    fndata.append("note", payimgData.note);
    setIsLoading(true);
    const resp = await uploadPaymentImage(fndata);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      // Visitor / Inquiry Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
      // await getleadlist();
      setLeadHistory(await featchleadhistory(myModal.lead_id));
      setpayimgData({});
      setpaymentimgModal(false);
      setfileimage();
    }
  };

  const handleChange = (panel) => {
    setExpanded(expanded == panel ? -1 : panel);
    // setExpanded(newExpanded ? panel : false);
  };

  const handlememberform = (e) => {
    setnewmemberdata({ ...memberdata, [e.target.name]: e.target.value });
  };

  const expo_columns = [
    { label: "No", key: "lead_id" },
    { label: "Lead Date", key: "date" },
    { label: "Type", key: "lead_type" },
    { label: "Gender", key: "gender" },
    { label: "Invoice Type", key: "invoice_generated_filter" },
    { label: "Name", key: "name" },
    { label: "Membership Expire", key: "Due_date" },
    { label: "Followup", key: "follow_ups" },
    // { label: "DOB", key: "dob" },
    { label: "Contact No", key: "l_contact_no" },
    { label: "Alternate Contact No", key: "alternate_contact_number" },
    { label: "Insurance", key: "new_insurance" },
    { label: "aadhaar Card Link", key: "aadhaarFilePath" },
    // { label: "FaceBook Id", key: "facebook_url" },
    // { label: "Instagram Id", key: "instagram_url" },
    { label: "Business Name", key: "l_business_name" },
    { label: "Business Category", key: "l_business_category" },
    { label: "Business Description", key: "l_business_description" },
    { label: "GST Number", key: "gst_no" },
    { label: "Email Id", key: "l_email" },
    { label: "Other Group", key: "other_group_name" },
    // { label: "Office Address", key: "l_address" },
    // { label: "Home Address", key: "l_h_address" },
    { label: "Payment Date", key: "payment_date" },
    { label: "Payment Mode", key: "new_payment_mode" },
    { label: "Professional Photo", key: "professionalPhotoPath" },
    // { label: "Payment Screenshot / Cheque Photo", key: "productFilePath" },
    { label: "Reference 1", key: "l_reference_1" },
    { label: "Reference 2", key: "l_reference_2" },
    { label: "Payment Screenshot", key: "paymentScreenshotPath" },
    { label: "Payment Note", key: "note" },
    { label: "Attendance Status", key: "new_Attendance_Status" },
    { label: "Created By", key: "createdBy" },
    { label: "Allocated To", key: "allocatedTo" },
    { label: "Phase", key: "lead_phase" },
    { label: "Reference By", key: "reference_by" },
    { label: "Renewal Reject Reason", key: "lead_reject_reason" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.lead_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row.date
    },
    {
      name: "Type",
      wrap: true,
      selector: (row) =>
        row.l_type == 0
          ? "Other"
          : row.l_type == 1
            ? row.attendance_status == 0
              ? "Visitor Present"
              : "Visitor Absent"
            : row.l_type == 2
              ? "Member Renewal"
              : row.l_type == 3
                ? "Confirm Member"
                : ""
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row.name
    },

    {
      name: "Contact No",
      wrap: true,
      selector: (row) => row.l_contact_no
    },
    {
      name: "Created By",
      wrap: true,
      selector: (row) => row.createdBy
    },
    {
      name: "Allocated To",
      wrap: true,
      selector: (row) => row.allocatedTo
    },
    {
      name: "Phase",
      wrap: true,
      selector: (row) => (
        <>
          {statusList &&
            statusList?.map((k) => {
              if (k.a_id == row.l_phase) {
                return k.name;
              }
            })}
        </>
      ),
      sortable: true
    },
    {
      name: "Refrence By",
      wrap: true,
      selector: (row) => row.reference_by
    }
  ];

  const submitMemberForm = async () => {
    setIsLoading_leadConvertMember_Btn(true);
    if (
      // Chapter
      memberdata.chpt_id != undefined &&
      memberdata.chpt_id != 0 &&
      // State
      memberdata.state_id != undefined &&
      memberdata.state_id != 0 &&
      // City
      memberdata.city_id != undefined &&
      memberdata.city_id != 0 &&
      // Member Name
      memberdata.name != undefined &&
      memberdata.name.trim().length != 0 &&
      memberdata.name.trim() != "" &&
      // Join Date
      memberdata.joining_date != undefined &&
      memberdata.joining_date.trim().length != 0 &&
      memberdata.joining_date.trim() != "" &&
      // Expiry Date
      memberdata.due_date != undefined &&
      memberdata.due_date.trim().length != 0 &&
      memberdata.due_date.trim() != "" &&
      // Password
      memberdata.password != undefined &&
      memberdata.password.trim().length != 0 &&
      memberdata.password.trim() != "" &&
      // Contact Number
      memberdata.l_contact_no != undefined &&
      memberdata.l_contact_no.trim().length != 0 &&
      memberdata.l_contact_no.trim() != "" &&
      // Business Number
      memberdata.l_business_name != undefined &&
      memberdata.l_business_name.trim().length != 0 &&
      memberdata.l_business_name.trim() != "" &&
      // Business Category
      memberdata.l_business_category != undefined &&
      memberdata.l_business_category.trim().length != 0 &&
      memberdata.l_business_category.trim() != ""
    ) {
      let fndata = new FormData();
      fndata.append("chpt_id", memberdata.chpt_id);
      fndata.append("gender", memberdata.gender);
      const memberName = (memberdata.first_name && memberdata.last_name)
        ? `${memberdata.first_name} ${memberdata.last_name}`
        : memberdata.name || "";
      fndata.append("m_name", memberName);
      fndata.append("mobile_no", memberdata.l_contact_no);
      fndata.append("m_email_id", memberdata.l_email);
      fndata.append("password", memberdata.password);
      fndata.append("type", memberdata.type);
      fndata.append("business_name", memberdata.l_business_name);
      fndata.append("business_category", memberdata.l_business_category);
      fndata.append("business_desc", memberdata.l_business_description);
      fndata.append("city_id", memberdata.city_id);
      fndata.append("state_id", memberdata.state_id);
      fndata.append("joining_date", memberdata.joining_date);
      fndata.append("due_date", memberdata.due_date);
      fndata.append("reference_m_id", memberdata.invite_by);
      fndata.append("member_type", memberdata.member_type);
      fndata.append("lead_id", memberdata.cardId);
      let resp = await insertmember(fndata);
      setIsLoading_leadConvertMember_Btn(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        let lfdata = new FormData();
        lfdata.append("lead_id", memberdata.cardId);
        lfdata.append("l_phase", memberdata.targetLaneId);
        lfdata.append("u_id", loginUser.u_id);
        lfdata.append("from_l_phase", memberdata.sourceLaneId);
        lfdata.append("base_due_date", moment(memberdata.joining_date, "DD-MM-YYYY").add(1, "years").format("DD-MM-YYYY"));
        lfdata.append("due_date", memberdata.due_date);

        const resp = await updateleadstatus(lfdata);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          setIsLoading_leadConvertMember_Btn(false);
          setConvertMemberModal(false);
          setLeadStatusChangeModal(false);
          setnewmemberdata({
            joining_date: moment().format("DD-MM-YYYY"),
            due_date: moment().add(1, "years").format("DD-MM-YYYY"),
            type: 0
          });
          // Visitor / Inquiry Lead API CALL
          setNewLan(initNewLan);
          await getAllPhaseLeads();
          // await getleadlist();
        }
      }
      setIsLoading_leadConvertMember_Btn(false);
    } else {
      let notify = notification({
        type: "error",
        message: `Please Fill All Required Information In Form`
      });
      notify();
      setIsLoading_leadConvertMember_Btn(false);
    }
  };

  const allowedFileTypes = [
    // Images
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    // PDFs
    "application/pdf",
    // Microsoft Word Documents
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
  ];

  // F  or Product & Professional Photos
  const allowFileImageTypes = [
    // Images
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif"
  ];
  const handleFileChange = (event, inputName) => {
    const files = inputName === "l_payment_photo" ? event.target.files : [event.target.files[0]];
    if (inputName === "l_payment_photo") {
      // Handle multiple files for payment photo
      const validFiles = [];
      const invalidFiles = [];

      Array.from(files).forEach((file) => {
        if (allowedFileTypes.includes(file.type)) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length > 0) {
        // setErrors({
        //   ...errors,
        //   [inputName]: `Invalid file type for: ${invalidFiles.join(", ")}. Upload File Must be an Image`
        // });
      } else {
        const existingFiles = Array.isArray(formdata[inputName]) ? formdata[inputName] : [];
        // Filter out duplicates
        const newFiles = validFiles.filter((newFile) => {
          return !existingFiles.some(
            (existingFile) =>
              existingFile.name === newFile.name && existingFile.size === newFile.size
          );
        });

        // If file already exists, replace it
        const updatedFiles = existingFiles.map((existingFile) => {
          const replacement = validFiles.find(
            (newFile) => newFile.name === existingFile.name && newFile.size === existingFile.size
          );
          return replacement || existingFile;
        });

        // Add completely new files
        const finalFiles = [...updatedFiles, ...newFiles];
        setformdata({ ...formdata, [inputName]: finalFiles });
        // setErrors({ ...errors, [inputName]: "" });
      }
    } else {
      const file = files[0];
      if (file) {
        if (file.size <= 11 * 1024 * 1024) {
          // 2MB in bytes
          if (
            (inputName == "aadhaar" ? allowedFileTypes : allowFileImageTypes).includes(file.type)
          ) {
            // setSelectedFile(file);
            setformdata({ ...formdata, [inputName]: file });
            // setErrors({ ...errors, [inputName]: "" });
            // setErrorMessage('');
          } else {
            // setErrors({
            //   ...errors,
            //   [inputName]: `${
            //     inputName == "aadhaar"
            //       ? "Upload File Must Be PDF, Image or Doc"
            //       : "Upload File Must be an Image"
            //   }  `,
            // });
            // setSelectedFile(null);
            // setErrorMessage('Invalid file type. Please upload an image, PDF, or DOC file.');
          }
        } else {
          // setErrors({
          //   ...errors,
          //   [inputName]: "File Sizes Greater Than 2MB Are Not Supported",
          // });
          // setSelectedFile(null);
          // setErrorMessage('File size exceeds 2MB limit.');
        }
      }
    }
  };

  const handleSwitchChange = (leadId) => {
    const lead = newLan.allLeadList.find((l) => l.id === leadId);
    if (lead) {
      setEditFormConfirmModal({ open: true, leadId: leadId, currentVal: lead.is_edit_form });
    }
  };

  const handleConfirmEditSwitch = async () => {
    const { leadId, currentVal } = editFormConfirmModal;
    const newVal = currentVal === 1 ? 0 : 1;

    const formData = new FormData();
    formData.append("lead_id", leadId);
    formData.append("is_edit_form", newVal);

    setIsLoading(true);
    const resp = await updateEditModeInMemberRenewalLead(formData);
    setIsLoading(false);

    if (resp.status === 1) {
      let notify = notification({
        type: "success",
        message: resp.message
      });
      notify();
    } else {
      let notify = notification({
        type: "error",
        message: resp.message
      });
      notify();
    }
    setEditFormConfirmModal({ open: false, leadId: null, currentVal: 0 });
    setNewLan(initNewLan);
    await getAllPhaseLeads();
  };

  const deleteLeadAttachmentHandler = async (
    lead_id,
    delete_file_key = "",
    name,
    l_p_photo_id,
    index
  ) => {
    const resp = await deleteLeadAttachment({ lead_id, delete_file_key, name, l_p_photo_id });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      if (delete_file_key === "l_payment_photo") {
        setformdata((prev) => ({
          ...prev,
          l_payment_photo: prev.l_payment_photo.filter((_, ind) => ind !== index),
          l_payment_photo_id: prev.l_payment_photo_id.filter((_, ind) => ind !== index)
        }));
      } else if (delete_file_key === "aadhaar") setformdata({ ...formdata, aadhaar: "" });
      else if (delete_file_key === "l_professional_photo")
        setformdata({ ...formdata, l_professional_photo: "" });
    }
  };

  useEffect(async () => {
    if (invoiceAmountVerifiedData?.isSubmit) {
      if (invoiceAmountVerifiedData?.isExpiryEdit) {
        await submitExpiryEdit();
      } else if (invoiceAmountVerifiedData?.isEdit) {
        await submitEditInvoiceDetails();
      } else {
        await leadStatusChange(
          invoiceAmountVerifiedData?.lead_id,
          invoiceAmountVerifiedData?.divValue,
          invoiceAmountVerifiedData?.from_l_phase
        );
      }
    }
  }, [invoiceAmountVerifiedData]);

  useEffect(() => {
    const base64data = Buffer.from(String(myModal?.lead_id)).toString("base64");

    setFormLink(Routes.LEADFORMPUBLICURL + "invoice-download-form/" + base64data);
  }, [myModal]);

  useEffect(() => {
    const init = async () => {
      await handleGetAttributeList();
      if (location.state?.lead_status != null && location.state?.lead_status != -1) {
        await getFilterLeadData();
      } else {
        getAllPhaseLeads();
      }
      getallcitylist();
    };
    init();
  }, []);

  useEffect(async () => {
    setcitylist(await fetchCityList(memberdata?.state_id));
  }, [memberdata?.state_id]);

  useEffect(async () => {
    allocatelist?.map((option) => {
      filterOption.push({ value: option.u_id, label: option.name });
    });
  }, [allocatelist]);

  useEffect(() => {
    let filtered = allocatelist?.filter((option) => option.city_id === filterlead.filterCity);

    let selectedUser = null;
    if (loginUser?.u_type == 0 || (loginUser?.u_type == 0 && loginUser?.is_subadmin == 1)) {
      selectedUser = filtered.find((user) => user?.u_type == 1);
    } else {
      selectedUser = filtered.find((user) => user?.u_id == filterlead.u_id);
    }

    filtered = filtered.map((option) => ({
      value: option.u_id,
      label: option.name
    }));

    setFilterOption(filtered || []);

    if (selectedUser) {
      setfilterlead((prev) => ({
        ...prev,
        filteruser: selectedUser.u_id
      }));
      // getAllPhaseLeads({ ...filterlead, filteruser: selectedUser.u_id });
    } else {
      setfilterlead((prev) => ({
        ...prev,
        filteruser: 0
      }));
    }
  }, [filterlead.filterCity, allocatelist]);

  useEffect(async () => {
    await getallocatelistbyid();
    setRejectReasonlist(await getLeadRejectReason());
    // await getleadlist();
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
    // setmemberlist(await GetAllMember(loginUser.city_id, loginUser.u_type));
    // Load All LVB Member List For Reference In Lead
    // get all member but only load  the active member only on the list

    let res = await GetAllMember(0, 0);
    let newMemberList = res.filter((member) => {
      return member.status == 1;
    });
    setmemberlist(newMemberList);
    setstatelist(await fetchStateList());
  }, []);

  const openInNewTab = async () => {
    navigator.clipboard.writeText(formLink);
    let notify = notification({
      type: "info",
      message: "Copy to clipboard",
      position: "top"
    });
    await notify();
  };

  const handleConfirmSendReminder = async () => {
    setIsLoading(true);
    const resp = await sendInvoiceReminderToMemberApi({ lead_id: reminderConfirmModal.leadId });
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    setReminderConfirmModal({ open: false, leadId: null });
  };

  // Directional drag rotation: tilt left when moving left, right when moving right
  useEffect(() => {
    let dragStartX = null;

    const getClientX = (e) => {
      if (e.clientX !== undefined) return e.clientX;
      if (e.touches && e.touches[0]) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
      return null;
    };

    const onDown = (e) => {
      const target = e.target.closest(
        ".smooth-dnd-draggable-wrapper, .react-trello-card, .myCard, .taskCard"
      );
      if (target) {
        const x = getClientX(e);
        if (x !== null) dragStartX = x;
      }
    };

    const onMove = (e) => {
      const ghost = document.querySelector(".smooth-dnd-ghost");
      if (!ghost || dragStartX === null) return;
      const currentX = getClientX(e);
      if (currentX === null) return;
      const deltaX = currentX - dragStartX;
      const cardEl = ghost.firstElementChild;
      if (!cardEl) return;
      // threshold to avoid flicker on tiny vertical moves
      if (deltaX < -5) {
        cardEl.style.transform = "rotate(-3deg)";
      } else if (deltaX > 5) {
        cardEl.style.transform = "rotate(3deg)";
      } else {
        cardEl.style.transform = "rotate(0deg)";
      }
      cardEl.style.transition = "transform 0.12s ease";
    };

    const onUp = () => {
      dragStartX = null;
      // reset ghost transform if still present (drop animation will handle removal)
      const ghost = document.querySelector(".smooth-dnd-ghost");
      if (ghost && ghost.firstElementChild) {
        ghost.firstElementChild.style.transform = "";
      }
    };

    document.addEventListener("mousedown", onDown, true);
    document.addEventListener("touchstart", onDown, { passive: true, capture: true });
    document.addEventListener("mousemove", onMove, true);
    document.addEventListener("touchmove", onMove, { passive: false, capture: true });
    document.addEventListener("mouseup", onUp, true);
    document.addEventListener("touchend", onUp, true);

    return () => {
      document.removeEventListener("mousedown", onDown, true);
      document.removeEventListener("touchstart", onDown, true);
      document.removeEventListener("mousemove", onMove, true);
      document.removeEventListener("touchmove", onMove, true);
      document.removeEventListener("mouseup", onUp, true);
      document.removeEventListener("touchend", onUp, true);
    };
  }, []);

  return (
    <>
      <Modal
        open={editFormConfirmModal.open}
        onClose={() => setEditFormConfirmModal({ open: false, leadId: null, currentVal: 0 })}
      >
        <Box sx={confirmModalstyle}>
          <div style={{ maxHeight: "100%", textAlign: "center" }}>
            <Icon style={{ height: "128px", width: "128px" }}>
              <ReportGmailerrorredOutlined
                color="warning"
                style={{ height: "128px", width: "128px", opacity: "1" }}
              />
            </Icon>
          </div>
          <Typography variant="h6" align="center" gutterBottom>
            Are you sure you want to {editFormConfirmModal.currentVal === 1 ? "disable" : "enable"}{" "}
            the edit form?
          </Typography>
          <Box display="flex" justifyContent="center" gap={2} mt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmEditSwitch}
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              onClick={() => setEditFormConfirmModal({ open: false, leadId: null, currentVal: 0 })}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={reminderConfirmModal.open}
        onClose={() => setReminderConfirmModal({ open: false, leadId: null })}
      >
        <Box sx={confirmModalstyle}>
          <div style={{ maxHeight: "100%", textAlign: "center" }}>
            <Icon style={{ height: "128px", width: "128px" }}>
              <NotificationsActive
                sx={{ color: "#ffc107", height: "128px", width: "128px", opacity: "1" }}
              />
            </Icon>
          </div>
          <Typography variant="h6" align="center" gutterBottom>
            Are you sure you want to send an invoice reminder to this member?
          </Typography>
          <Box display="flex" justifyContent="center" gap={2} mt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmSendReminder}
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              onClick={() => setReminderConfirmModal({ open: false, leadId: null })}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        style={{ overflow: "scroll" }}
        open={myModal.mval}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadDetailsModelStyle}>
          <Typography
            id="modal-modal-title"
            variant="div"
            component="div"
            style={{
              margin: "10px",
              textAlign: "center",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div style={{ width: "100%" }}>
              <Tooltip
                title="Edit Lead"
                onClick={async () => {
                  await getLeadByLeadId(myModal.lead_id);
                  await cancelModal();
                  await setStep(2);
                }}
              >
                <IconButton>
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>
              {[1, 2].includes(leadHistory?.leaddetails?.l_phase) && (
                <Tooltip
                  title="Add Followup"
                  onClick={async () => {
                    // await setMyModal({ mval: false, lead_id: 0 });
                    await setFollowUpData({
                      ...followUpData,
                      lead_id: myModal.lead_id
                    });
                    await setFollowUpModal(true);
                  }}
                >
                  <IconButton>
                    <SendSharp color="info" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip
                title="Transfer Lead"
                onClick={async () => {
                  await setLeadTransData({
                    ...leadtransData,
                    lead_id: myModal.lead_id
                  });
                  await setLeadTransModal(true);
                }}
              >
                <IconButton>
                  <PersonAddAltSharp color="success" />
                </IconButton>
              </Tooltip>
            </div>

            <div>
              <Tooltip
                title="Close"
                onClick={async () => {
                  await cancelModal();
                  setValue("1");
                }}
              >
                <IconButton>
                  <Close color="blank" />
                </IconButton>
              </Tooltip>
            </div>
          </Typography>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example" centered>
                <Tab
                  icon={<LeaderboardSharp />}
                  iconPosition="end"
                  label="Lead Details"
                  value="1"
                />
                <Tab icon={<ThumbUpAlt />} iconPosition="end" label="Follow Up History" value="2" />
                <Tab icon={<AutoGraphSharp />} iconPosition="end" label="Activity Log" value="3" />
              </TabList>
            </Box>
            <div
              style={{
                maxHeight: "500px",
                height: "500px",
                overflowY: "scroll"
              }}
            >
              <TabPanel value="1">
                <>
                  <Grid container spacing={2}>
                    <Grid xs={8} item>
                      {/* Personal Details Card */}
                      <Card style={{ border: "1px solid #abababb5" }}>
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Personal Information
                          </h3>
                          <Grid container spacing={0}>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Name </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.name || "-"}
                                </p>
                              </div>
                            </Grid>
                            {![...IsNotValue, 0].includes(leadHistory?.leaddetails?.gender) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Gender </h4>
                                  <p className="word-break-all">
                                    {gender[leadHistory?.leaddetails?.gender]?.label || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.dob) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>DOB </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.dob || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_contact_no) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Contact No </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_contact_no || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(
                              leadHistory?.leaddetails?.alternate_contact_number
                            ) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Alternate Contact No </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.alternate_contact_number || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {leadHistory?.leaddetails?.insuranceType !== "-1" ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Insurance</h4>
                                  <p className="word-break-all">
                                    {/* {leadHistory?.leaddetails?.insuranceType == 1
                                    ? "Health Insurance"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      2
                                    ? "Life Insurance"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      3
                                    ? "Term Insurance"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      4
                                    ? "None"
                                    : leadHistory?.leaddetails?.insuranceType ==
                                      0
                                    ? `Other - ${leadHistory?.leaddetails?.otherInsurance}`
                                    : "-"} */}

                                    {leadHistory?.leaddetails?.insuranceType
                                      ?.split(",")
                                      ?.map((type, index) => (
                                        <span key={index}>
                                          {type == 1
                                            ? "Health Insurance"
                                            : type == 2
                                              ? "Life Insurance"
                                              : type == 3
                                                ? "Term Insurance"
                                                : type == 4
                                                  ? "None"
                                                  : type == 0
                                                    ? `Other - ${leadHistory?.leaddetails?.otherInsurance}`
                                                    : "-"}
                                          {index !==
                                            leadHistory?.leaddetails?.insuranceType?.split(",")
                                              .length -
                                            1 && ", "}
                                        </span>
                                      ))}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            <Grid xs={6} item>
                              {!IsNotValue.includes(leadHistory?.leaddetails?.aadhaar) ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <Grid container spacing={0}>
                                    <Grid xs={9} item>
                                      <h4 style={{ color: "#838383" }}>Aadhaar Card</h4>
                                      <p className="word-break-all">
                                        {leadHistory?.leaddetails?.aadhaar || "-"}
                                      </p>
                                    </Grid>

                                    {leadHistory?.leaddetails?.aadhaar && (
                                      <Grid xs={3} item>
                                        <div
                                          className="d-flex"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "end",
                                            justifyContent: "space-between"
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer"
                                            href="#"
                                            onClick={() => {
                                              saveAs(
                                                Routes.API_HOSTNAME +
                                                "images/leadMemberAadhaar/" +
                                                leadHistory?.leaddetails?.aadhaar,
                                                leadHistory?.leaddetails?.aadhaar
                                              );
                                            }}
                                          >
                                            Download
                                          </a>
                                          <a
                                            className="cursor-pointer"
                                            href={
                                              Routes.API_HOSTNAME +
                                              "images/leadMemberAadhaar/" +
                                              leadHistory?.leaddetails?.aadhaar
                                            }
                                            target="_blank"
                                          >
                                            Open
                                          </a>
                                        </div>
                                      </Grid>
                                    )}
                                  </Grid>
                                </div>
                              ) : (
                                ""
                              )}
                            </Grid>

                            {!IsNotValue.includes(leadHistory?.leaddetails?.facebook_url) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Facebook ID</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.facebook_url || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.instagram_url) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Instagram ID</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.instagram_url || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </div>
                      </Card>

                      {/* Business Details Card */}
                      <Card
                        style={{
                          border: "1px solid #abababb5",
                          marginTop: "15px"
                        }}
                      >
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Business Information
                          </h3>
                          <Grid container spacing={0}>
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_business_name) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Business Name</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_business_name || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_business_category) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Business Category</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_business_category || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(
                              leadHistory?.leaddetails?.l_business_description
                            ) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Business Description</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_business_description || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>GST No </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.gst_no || "-"}
                                </p>
                              </div>
                            </Grid>
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_email) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Email ID</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_email || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.other_group_name) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Other Group Name</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.other_group_name || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}

                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_address) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Office Address</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_address || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}

                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_h_address) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Home Address</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_h_address || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}

                            {!IsNotValue.includes(leadHistory?.leaddetails?.payment_date) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Payment Date</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.payment_date || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {leadHistory?.leaddetails?.payment_mode !== undefined &&
                              leadHistory?.leaddetails?.payment_mode !== null &&
                              leadHistory?.leaddetails?.payment_mode !== "" ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Payment Mode</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.payment_mode == 0
                                      ? "Cash"
                                      : leadHistory?.leaddetails?.payment_mode == 1
                                        ? "Transfer"
                                        : leadHistory?.leaddetails?.payment_mode == 2
                                          ? "Cheque"
                                          : "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            <Grid xs={6} item>
                              {leadHistory?.leaddetails?.l_professional_photo ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <Grid container spacing={0}>
                                    <Grid xs={9} item>
                                      <h4 style={{ color: "#838383" }}>Professional Photo</h4>
                                      <p className="word-break-all">
                                        {leadHistory?.leaddetails?.l_professional_photo || "-"}
                                      </p>
                                    </Grid>
                                    <Grid xs={3} item>
                                      <div
                                        className="d-flex"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "end",
                                          justifyContent: "space-between"
                                        }}
                                      >
                                        <a
                                          className="cursor-pointer"
                                          href="#"
                                          onClick={() => {
                                            saveAs(
                                              Routes.API_HOSTNAME +
                                              "images/leadMemberProfile/" +
                                              leadHistory?.leaddetails?.l_professional_photo,
                                              leadHistory?.leaddetails?.l_professional_photo
                                            );
                                          }}
                                        >
                                          Download
                                        </a>
                                        <a
                                          className="cursor-pointer"
                                          href={
                                            Routes.API_HOSTNAME +
                                            "images/leadMemberProfile/" +
                                            leadHistory?.leaddetails?.l_professional_photo
                                          }
                                          target="_blank"
                                        >
                                          Open
                                        </a>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              ) : (
                                ""
                              )}
                            </Grid>
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_payment_photo) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <Grid container spacing={0}>
                                    <Grid xs={9} item>
                                      <h4 style={{ color: "#838383" }}>
                                        Payment Screenshot / Cheque Photo{" "}
                                      </h4>
                                    </Grid>
                                    {Array.isArray(leadHistory?.leaddetails?.l_payment_photo) &&
                                      leadHistory?.leaddetails?.l_payment_photo.length > 0 &&
                                      leadHistory?.leaddetails?.l_payment_photo.map(
                                        (photo, index) => (
                                          <Grid xs={12} item key={index}>
                                            <div
                                              className="d-flex"
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                borderBottom:
                                                  index !==
                                                    leadHistory?.leaddetails?.l_payment_photo.length -
                                                    1
                                                    ? "1px solid #abababb5"
                                                    : "none",
                                                paddingBottom: "5px",
                                                marginBottom: "10px"
                                              }}
                                            >
                                              <p className="word-break-all">{photo}</p>
                                              <div>
                                                <a
                                                  className="cursor-pointer"
                                                  href="#"
                                                  onClick={() => {
                                                    saveAs(
                                                      Routes.API_HOSTNAME +
                                                      "images/leadMemberPayment/" +
                                                      photo,
                                                      photo
                                                    );
                                                  }}
                                                >
                                                  Download
                                                </a>
                                                <br />
                                                <a
                                                  className="cursor-pointer"
                                                  href={
                                                    Routes.API_HOSTNAME +
                                                    "images/leadMemberPayment/" +
                                                    photo
                                                  }
                                                  target="_blank"
                                                >
                                                  Open
                                                </a>
                                              </div>
                                            </div>
                                          </Grid>
                                        )
                                      )}
                                  </Grid>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}

                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_reference_1) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Reference 1</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_reference_1 || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {!IsNotValue.includes(leadHistory?.leaddetails?.l_reference_2) ? (
                              <Grid xs={6} item>
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Reference 2</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_reference_2 || "-"}
                                  </p>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </div>
                      </Card>

                      {/* Invoice Details Card */}



                      {(["6", "7"]?.includes(myModal?.l_phase?.toString()) && leadHistory?.leaddetails?.last_i_id != -1) ? (
                        <Card
                          style={{
                            border: "1px solid #abababb5",
                            marginTop: "15px"
                          }}
                        >
                          <div>
                            <Box
                              sx={{
                                padding: "15px",
                                background: "#1c4766",
                                color: "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}
                            >
                              <h3 style={{ margin: 0 }}>Invoice Details</h3>
                              {(loginUser?.u_type == 0 ||
                                (loginUser?.u_type == 2 && loginUser?.management_p == 1)) &&
                                leadHistory?.leaddetails?.last_i_id === 0 && (
                                  <IconButton
                                    size="small"
                                    sx={{ color: "#fff" }}
                                    onClick={() => {
                                      setInvoiceAmountVerifiedData({
                                        isEdit: true,
                                        lead_id: leadHistory?.leaddetails?.lead_id,
                                        i_amount: leadHistory?.leaddetails?.invoice_amt,
                                        base_i_amount: leadHistory?.leaddetails?.base_i_amount,
                                        payment_mode: leadHistory?.leaddetails?.payment_mode,
                                        payment_date: leadHistory?.leaddetails?.payment_date,
                                        i_item_id: leadHistory?.leaddetails?.i_item_id,
                                        member_id: leadHistory?.leaddetails?.member_id,
                                        invoice_expiry_date: leadHistory?.leaddetails?.invoice_expiry_date,
                                        joining_date: leadHistory?.leaddetails?.joining_date,
                                        due_date: leadHistory?.leaddetails?.due_date,
                                        previous_due_date: leadHistory?.leaddetails?.previous_due_date,
                                        is_renewal: leadHistory?.leaddetails?.l_type == 2
                                      });
                                      toggleInvoiceAmountVerifiedModal();
                                    }}
                                  >
                                    <EditSharp />
                                  </IconButton>
                                )}
                            </Box>

                            <Grid container spacing={1}>
                              <Grid item xs={12} sm={12} md={12}>
                                <Box sx={{ py: 1 }}>
                                  {/* <Card> */}
                                  {leadHistory?.leaddetails?.last_i_id === 0 && (
                                    <>
                                      <CardHeader
                                        title={
                                          <>
                                            <span>Invoice Generate Link</span>
                                            <span
                                              onClick={async () => {
                                                openInNewTab();
                                              }}
                                            >
                                              <Tooltip title="Click to Copy Link">
                                                <IconButton>
                                                  <ContentCopy color="action" />
                                                </IconButton>
                                              </Tooltip>
                                            </span>
                                          </>
                                        }
                                      />
                                      <Box sx={{ px: 3, py: 1 }}>
                                        <div style={{ display: "flex" }}>
                                          <span>
                                            <Link
                                              color="primary"
                                              className="RotateIcon"
                                              style={{ transform: "rotate(140deg)" }}
                                            />
                                          </span>
                                          <span
                                            onClick={() => window.open(formLink, "_blank")}
                                            style={{
                                              marginLeft: "5px",
                                              wordBreak: "break-all",
                                              color: "#1976d2",
                                              textDecoration: "underline",
                                              cursor: "pointer"
                                            }}
                                          >
                                            {formLink}
                                          </span>
                                        </div>
                                      </Box>
                                    </>
                                  )}

                                  {leadHistory?.leaddetails?.last_i_id !== 0 &&
                                    leadHistory?.leaddetails?.i_generate_date && (
                                      <Box sx={{ px: 3, py: 1 }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                            Invoice Generate Date :
                                          </span>
                                          <span>
                                            {leadHistory?.leaddetails?.i_generate_date}
                                          </span>
                                        </div>
                                      </Box>
                                    )}

                                  {leadHistory?.leaddetails?.last_i_id === 0 && (
                                    <>
                                      {leadHistory?.leaddetails?.invoice_amt && (
                                        <Box sx={{ px: 3, py: 1 }}>
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                              Invoice Amount :
                                            </span>
                                            <span>{leadHistory?.leaddetails?.invoice_amt}</span>
                                          </div>
                                        </Box>
                                      )}
                                      {leadHistory?.leaddetails?.invoice_amt == 0 && leadHistory?.leaddetails?.base_i_amount && (
                                        <Box sx={{ px: 3, py: 1 }}>
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                              Invoice Base Amount :
                                            </span>
                                            <span>{leadHistory?.leaddetails?.base_i_amount}</span>
                                          </div>
                                        </Box>
                                      )}
                                      {leadHistory?.leaddetails?.i_p_name && (
                                        <Box sx={{ px: 3, py: 1 }}>
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                              Product Name :
                                            </span>
                                            <span>{leadHistory?.leaddetails?.i_p_name}</span>
                                          </div>
                                        </Box>
                                      )}
                                      {leadHistory?.leaddetails?.payment_mode !== undefined &&
                                        leadHistory?.leaddetails?.payment_mode !== null && (
                                          <Box sx={{ px: 3, py: 1 }}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                              <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                                Payment Mode :
                                              </span>
                                              <span>
                                                {leadHistory?.leaddetails?.payment_mode == 0
                                                  ? "Cash"
                                                  : leadHistory?.leaddetails?.payment_mode == 1
                                                    ? "Transfer"
                                                    : leadHistory?.leaddetails?.payment_mode == 2
                                                      ? "Cheque"
                                                      : leadHistory?.leaddetails?.payment_mode == 3
                                                        ? "None"
                                                        : "-"}
                                              </span>
                                            </div>
                                          </Box>
                                        )}
                                      {leadHistory?.leaddetails?.payment_date && (
                                        <Box sx={{ px: 3, py: 1 }}>
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                              Payment Date :
                                            </span>
                                            <span>{leadHistory?.leaddetails?.payment_date}</span>
                                          </div>
                                        </Box>
                                      )}
                                      {leadHistory?.leaddetails?.invoice_expiry_date && (
                                        <Box sx={{ px: 3, py: 1 }}>
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                              Invoice Expiry Date :
                                            </span>
                                            <span style={{ marginRight: "10px" }}>
                                              {leadHistory?.leaddetails?.invoice_expiry_date}
                                            </span>
                                            <span>
                                              {(() => {
                                                const days = moment(
                                                  leadHistory?.leaddetails?.invoice_expiry_date,
                                                  "DD-MM-YYYY"
                                                )
                                                  .startOf("day")
                                                  .diff(moment().startOf("day"), "days");
                                                return (
                                                  <Label color={days <= 0 ? "error" : "success"}>
                                                    {days > 0
                                                      ? `${days} days left`
                                                      : days < 0
                                                        ? `Expired by ${Math.abs(days)} days`
                                                        : `Expires today`}
                                                  </Label>
                                                );
                                              })()}
                                            </span>
                                          </div>
                                        </Box>
                                      )}
                                    </>
                                  )}

                                  {/* </Card> */}
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} sx={{ m: 3 }}>
                                {leadHistory?.leaddetails?.last_i_id !== 0 && (
                                  <Button
                                    variant="contained"
                                    onClick={async () => {
                                      handleDownload(
                                        `${Routes.API_HOSTNAME}invoice-pdf/${leadHistory?.leaddetails?.invoice_url}`,
                                        leadHistory?.leaddetails?.invoice_url
                                      );
                                    }}
                                  >
                                    Download Invoice{" "}
                                  </Button>
                                )}

                                {(loginUser?.u_type == 0 ||
                                  (loginUser?.u_type == 2 && loginUser?.management_p == 1)) && leadHistory?.leaddetails?.last_i_id === 0 && (
                                    <Button
                                      variant="contained"
                                      style={{ marginRight: "15px" }}

                                      onClick={() => {
                                        setGenerateInvoiceModal(true);
                                      }}
                                    >
                                      Generate Invoice{" "}

                                    </Button>
                                  )}
                              </Grid>
                            </Grid>
                          </div>
                        </Card>
                      ) : null}

                      {/* Membership Expiry Details Card */}
                      {(["6", "7"]?.includes(myModal?.l_phase?.toString())) ? (
                        <Card
                          style={{
                            border: "1px solid #abababb5",
                            marginTop: "15px"
                          }}
                        >
                          <div>
                            <Box
                              sx={{
                                padding: "15px",
                                background: "#1c4766",
                                color: "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}
                            >
                              <h3 style={{ margin: 0 }}>Membership Expiry Details</h3>
                              {(loginUser?.u_type == 0 ||
                                (loginUser?.u_type == 2 && loginUser?.management_p == 1)) &&
                                (leadHistory?.leaddetails?.due_date ||
                                  leadHistory?.leaddetails?.joining_date) &&
                                (leadHistory?.leaddetails?.l_phase == 6) && (
                                  <IconButton
                                    size="small"
                                    sx={{ color: "#fff" }}
                                    onClick={() => {
                                      setInvoiceAmountVerifiedData({
                                        isEdit: true,
                                        isExpiryEdit: true,
                                        lead_id: leadHistory?.leaddetails?.lead_id,
                                        member_id: leadHistory?.leaddetails?.member_id,
                                        i_amount: leadHistory?.leaddetails?.invoice_amt,
                                        base_i_amount: leadHistory?.leaddetails?.base_i_amount,
                                        payment_mode: leadHistory?.leaddetails?.payment_mode,
                                        payment_date: leadHistory?.leaddetails?.payment_date,
                                        i_item_id: leadHistory?.leaddetails?.i_item_id,
                                        invoice_expiry_date: leadHistory?.leaddetails?.invoice_expiry_date,
                                        joining_date: leadHistory?.leaddetails?.joining_date,
                                        due_date: leadHistory?.leaddetails?.due_date,
                                        previous_due_date: leadHistory?.leaddetails?.previous_due_date,
                                        is_renewal: leadHistory?.leaddetails?.l_type == 2
                                      });
                                      toggleInvoiceAmountVerifiedModal();
                                    }}
                                  >
                                    <EditSharp />
                                  </IconButton>
                                )}
                            </Box>

                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Box sx={{ px: 3, py: 1 }}>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                      Joining Date :
                                    </span>
                                    <span>{leadHistory?.leaddetails?.joining_date || "-"}</span>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                      Expiry Date :
                                    </span>
                                    <span style={{ marginRight: "10px" }}>
                                      {leadHistory?.leaddetails?.due_date || "-"}
                                    </span>
                                    <span>
                                      {(() => {
                                        const joining = leadHistory?.leaddetails?.joining_date;
                                        const due = leadHistory?.leaddetails?.due_date;
                                        const prev = leadHistory?.leaddetails?.joining_date;
                                        const isRenewalLead = leadHistory?.leaddetails?.l_type == 2;
                                        if (!due) return null;
                                        const expected = getDefaultExpiryDate(
                                          leadHistory?.leaddetails?.payment_date || joining,
                                          isRenewalLead ? prev || due : null
                                        );
                                        const counter = formatExpiryExtension(due, expected);
                                        if (counter.tone == "success")
                                          return <Label color="success">{counter.text}</Label>;
                                        if (counter.tone == "error")
                                          return <Label color="error">{counter.text}</Label>;
                                        return (
                                          <>
                                            <Label color="default">{counter.text}</Label>
                                            <span style={{ color: "#838383" }}> (00)</span>
                                          </>
                                        );
                                      })()}
                                    </span>
                                  </div>
                                </Box>
                              </Grid>
                            </Grid>
                          </div>
                        </Card>
                      ) : null}
                    </Grid>

                    {/* Right Side  */}
                    <Grid xs={4} item>
                      <div style={{ position: "sticky", top: "10px" }}>
                        <Card
                          style={{
                            border: "1px solid #abababb5"
                          }}
                        >
                          <div>
                            <h3
                              style={{
                                padding: "15px",
                                background: "#1c4766",
                                color: "#fff"
                              }}
                            >
                              Lead Information
                            </h3>
                            <div>
                              {!IsNotValue.includes(leadHistory?.leaddetails?.date) ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Date </h4>
                                  <p className="word-break-all">{leadHistory?.leaddetails?.date}</p>
                                </div>
                              ) : (
                                ""
                              )}
                              {leadHistory?.leaddetails?.l_type !== undefined &&
                                leadHistory?.leaddetails?.l_type !== null &&
                                leadHistory?.leaddetails?.l_type !== "" ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Lead Type </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.l_type == 0
                                      ? "Other"
                                      : leadHistory?.leaddetails?.l_type == 1
                                        ? "Visitor"
                                        : leadHistory?.leaddetails?.l_type == 2
                                          ? "Member Renewal"
                                          : leadHistory?.leaddetails?.l_type == 3
                                            ? "Confirm Member"
                                            : ""}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Lead Status </h4>
                                <p className="word-break-all">
                                  {statusList?.map((e) => {
                                    if (e.a_id == leadHistory?.leaddetails?.l_phase) {
                                      return e.name;
                                    }
                                  })}
                                </p>
                              </div>
                              {!IsNotValue.includes(
                                leadHistory?.leaddetails?.lead_reject_reason
                              ) ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Reject Reason </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.lead_reject_reason}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.allocatedTo) ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Allocated To</h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.allocatedTo}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.createdBy) ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Created By </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.createdBy}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.reference_by) ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px",
                                    borderBottom: "1px solid #abababb5"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Reference By </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.reference_by || "-"}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              {!IsNotValue.includes(leadHistory?.leaddetails?.note) ? (
                                <div
                                  style={{
                                    margin: "5px 15px",
                                    paddingBottom: "5px"
                                  }}
                                >
                                  <h4 style={{ color: "#838383" }}>Payment Note </h4>
                                  <p className="word-break-all">
                                    {leadHistory?.leaddetails?.note || "-"}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Card>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            margin: "10px auto"
                          }}
                        >
                          <div style={{ padding: "5px" }}>
                            {leadHistory?.leaddetails?.l_phase == 5 && (
                              <Button
                                variant="contained"
                                component="label"
                                onClick={() => {
                                  setpaymentimgModal(true);
                                }}
                              >
                                Upload Payment Details
                                {/* <input
                                id="file"
                                name="file"
                                type="file"
                                hidden
                                onChange={async (event) => {
                                  await paymentimg(event.currentTarget.files[0], myModal.lead_id);
                                }}
                                className="form-control"
                              /> */}
                              </Button>
                            )}
                          </div>
                          <div style={{ padding: "5px" }}>
                            {leadHistory?.leaddetails?.l_payment_ss != null && (
                              <Button
                                // href={`${Routes.API_HOSTNAME}images/payment/${leadHistory?.leaddetails?.l_payment_ss}`}
                                variant="contained"
                                component="label"
                                onClick={() => {
                                  saveAs(
                                    `${Routes.API_HOSTNAME}images/payment/${leadHistory?.leaddetails?.l_payment_ss}`,
                                    `${leadHistory?.leaddetails?.name}_Payment`
                                  );
                                }}
                              >
                                Click To Download
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </>
              </TabPanel>
              <TabPanel value="2">
                <>
                  {leadHistory?.followupdetails?.map((e, key) => {
                    return (
                      <Accordion
                        style={{
                          boxShadow: "#0000003d 0px 0px 6px 0px",
                          marginBottom: "10px",
                          borderRadius: "11px",
                          border: "1px solid #1c47669c"
                        }}
                        expanded={expanded === key}
                        onChange={() => handleChange(key)}
                      >
                        <AccordionSummary
                          style={{
                            background: "#1c4766",
                            color: "#fff",
                            borderRadius: "10px"
                          }}
                          aria-controls="panel1d-content"
                          id={key}
                        // panel1d-header
                        >
                          <Typography>{e.userName + " ( " + e.date + " )"}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            <p>Next Follow Date : {e.next_f_date}</p>
                            <p>Comment : {e.comment}</p>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </>
              </TabPanel>
              <TabPanel value="3">
                <Timeline position="right">
                  {leadHistory?.activitylog?.map((e) => {
                    return (
                      <TimelineItem>
                        <TimelineOppositeContent
                          color="text.secondary"
                          style={{
                            textAlign: "left",
                            width: "150px",
                            maxWidth: "150px"
                          }}
                        >
                          {e.date}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot color="primary" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent style={{ wordBreak: "break-word" }}>
                          <h4>{e.userName}</h4>
                          <p>{e.l_a_description}</p>
                        </TimelineContent>
                      </TimelineItem>
                    );
                  })}
                </Timeline>
              </TabPanel>
            </div>
          </TabContext>
        </Box>
      </Modal>
      <Modal
        open={followUpModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Follow Up
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Card style={{ padding: "25px", paddingBottom: "25px" }}>
                  <Stack spacing={10} style={{ marginBottom: "15px" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            style={{ marginTop: "15px" }}
                          >
                            <DatePicker
                              type="date"
                              name="next_f_date "
                              label="Next FollowUp date"
                              inputFormat="dd/MM/yyyy"
                              value={moment(followUpData.next_f_date, "DD-MM-YYYY")}
                              onChange={(newDate) => {
                                setFollowUpData({
                                  ...followUpData,
                                  next_f_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                });
                              }}
                              renderInput={(params) => <TextField {...params} />}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack spacing={3} style={{ marginBottom: "15px" }}>
                          <LimitedTextField
                            limitKey="lead_followup_comment"
                            fullWidth
                            rows={4}
                          multiline
                            label="Comment"
                            name="comment"
                            value={followUpData.comment || ""}
                            onChange={(e) =>
                              setFollowUpData((prev) => ({
                                ...prev,
                                comment: e.target.value
                              }))
                            }
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Card>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setFollowUpModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitfollowup}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={leadtransModal}
        // onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Transfer
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                {/* <Card style={{ padding: "25px", paddingBottom: "25px" }}> */}
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Transer To</label>
                        <Select
                          value={
                            allocatelist &&
                            allocatelist
                              ?.map((p) => {
                                if (p.u_id == leadtransData.l_transfer_to) {
                                  return { value: p.u_id, label: p.u_name };
                                }
                              })
                              .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="l_transfer_to"
                          onChange={(e) => {
                            setLeadTransData({
                              ...leadtransData,
                              l_transfer_to: e.value
                            });
                          }}
                          options={
                            allocatelist != null &&
                            allocatelist?.map((p) => {
                              return { value: p.u_id, label: p.u_name };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
                {/* </Card> */}
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setLeadTransModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitleadtransfer}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={paymentimgModal}
        // onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Payment Details
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                {/* <Card style={{ padding: "25px", paddingBottom: "25px" }}> */}
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Payment Note"
                          name="note"
                          // value={formdata?.t_title}
                          onChange={(e) => {
                            setpayimgData({
                              ...payimgData,
                              note: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      {/* {fileimage != undefined && (
                        <img
                          src={fileimage}
                          alt="img"
                          width="100px"
                          height="80px"
                          style={{ margin: "5px" }}
                        />
                      )} */}
                      {/* <Stack spacing={3} style={{ marginBottom: "15px" }}> */}
                      <Button variant="contained" component="label">
                        Upload Payment ScreenShot
                        <input
                          id="file"
                          name="file"
                          type="file"
                          multiple
                          hidden
                          onChange={async (event) => {
                            const files = Array.from(event.currentTarget.files);

                            setpayimgData({
                              ...payimgData,
                              img: files
                            });

                            setfileimage(files.map((file) => URL.createObjectURL(file)));

                            // setpayimgData({
                            //   ...payimgData,
                            //   img: event.currentTarget.files[0]
                            // });
                            // setfileimage(URL.createObjectURL(event.currentTarget.files[0]));
                          }}
                          className="form-control"
                        />
                      </Button>
                      {/* </Stack> */}
                    </Grid>
                  </Grid>
                </Stack>
                {/* </Card> */}
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setpaymentimgModal(false);
                  setfileimage();
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  paymentimg();
                }}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={convertmemberModal}
        // onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...leadDetailsModelStyle }}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Convert To Member
          </Typography>
          <div style={{ padding: "10px" }}>
            <div
              style={{
                maxHeight: "420px",
                overflow: "scroll",
                padding: "10px"
              }}
            >
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                {/* <Card style={{ padding: "25px", paddingBottom: "25px" }}> */}
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <ChapterSelectDropDown
                          dropDownLabel={"Select Chapter"}
                          selectedState={memberdata}
                          chapterKey="chpt_id"
                          // customMenuPortalTarget={false}
                          handleChange={(e) => {
                            setnewmemberdata({
                              ...memberdata,
                              chpt_id: e.value,
                              state_id: chaptlist?.find((item) => item?.chpt_id == e.value)
                                ?.state_id,
                              city_id: chaptlist?.find((item) => item?.chpt_id == e.value)?.city_id
                            });
                          }}
                          onlyActiveChapter={true}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Reference By</label>
                        <Select
                          value={
                            memberlist == null
                              ? { value: 0, label: "Select Chapter" }
                              : memberlist
                                ?.map((c) => {
                                  if (c.m_id == memberdata.invite_by) {
                                    return {
                                      value: c.m_id,
                                      label:
                                        c.m_name +
                                        " (" +
                                        c.business_name +
                                        ") [" +
                                        c.chpt_name +
                                        "]"
                                    };
                                  }
                                })
                                .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="invite_by"
                          onChange={(e) => {
                            setnewmemberdata({
                              ...memberdata,
                              invite_by: e.value
                            });
                          }}
                          options={
                            memberlist != null &&
                            memberlist?.map((chpt) => {
                              return {
                                value: chpt.m_id,
                                label:
                                  chpt.m_name +
                                  " (" +
                                  chpt.business_name +
                                  ") [" +
                                  chpt.chpt_name +
                                  "]"
                              };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Select State</label>
                        <Select
                          value={
                            statelist == null
                              ? { value: 0, label: "Select State" }
                              : statelist
                                ?.map((c) => {
                                  if (c.state_id == memberdata.state_id) {
                                    return {
                                      value: c.state_id,
                                      label: c.state_name
                                    };
                                  }
                                })
                                .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="state_id"
                          onChange={async (e) => {
                            setnewmemberdata({
                              ...memberdata,
                              state_id: e.value
                            });
                            setcitylist(await fetchCityList(e.value));
                          }}
                          options={
                            statelist != null &&
                            statelist?.map(
                              (sta) => {
                                return {
                                  value: sta.state_id,
                                  label: sta.state_name
                                };
                              }
                              // <MenuItem value={sta.state_id}>{sta.state_name}</MenuItem>
                            )
                          }
                          isDisabled={true}
                        ></Select>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Select City</label>
                        <Select
                          value={
                            citylist?.length == 0
                              ? { value: 0, label: "Select City" }
                              : citylist &&
                              citylist.length != 0 &&
                              citylist
                                ?.map((c) => {
                                  if (c.city_id == memberdata.city_id) {
                                    return {
                                      value: c.city_id,
                                      label: c.city_name
                                    };
                                  }
                                })
                                .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="city_id"
                          onChange={(e) => {
                            setnewmemberdata({
                              ...memberdata,
                              city_id: e.value
                            });
                          }}
                          options={
                            citylist && citylist.length > 0
                              ? citylist?.map((c) => {
                                return {
                                  value: c.city_id,
                                  label: c.city_name
                                };
                              })
                              : []
                          }
                          isDisabled={true}
                        ></Select>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
                        {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="joindate"
                            label="Joining Date "
                            value={moment(memberdata.joining_date, "DD-MM-YYYY")}
                            inputFormat="dd/MM/yyyy"
                            disabled={(loginUser.u_type == 0 || (loginUser.u_type == 2 && loginUser.p_user_id == 1)) ? false : true}
                            maxDate={loginUser.u_type == 1 ? new Date() : undefined}
                            onChange={(newDate) => {
                              setnewmemberdata({
                                ...memberdata,
                                joining_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY"),
                                due_date: moment(newDate, "DD-MM-YYYY")
                                  .add(1, "years")
                                  .format("DD-MM-YYYY")
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onKeyDown={
                                  loginUser.u_type == 1 ? (e) => e.preventDefault() : undefined
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            label="Expire Date "
                            name="expiredate"
                            value={moment(memberdata.due_date, "DD-MM-YYYY")}
                            inputFormat="dd/MM/yyyy"
                            {...(loginUser.u_type == 1
                              ? {
                                minDate: moment(memberdata.joining_date, "DD-MM-YYYY").toDate(),
                                maxDate: moment(
                                  memberdata.admin_limit_date,
                                  "DD-MM-YYYY"
                                )
                                  .endOf("day")
                                  .toDate()
                              }
                              : {})}
                            onChange={(newDate) => {
                              setnewmemberdata({
                                ...memberdata,
                                due_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onKeyDown={
                                  loginUser.u_type == 1 ? (e) => e.preventDefault() : undefined
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Gender</FormLabel>

                          <RadioGroup
                            name="gender"
                            row // remove this if you want vertical
                            value={memberdata?.gender || 0}
                            onChange={handlememberform}
                          >
                            {gender
                              .filter((g) => g.value !== 0) // remove "Select Gender"
                              .map((g) => (
                                <FormControlLabel
                                  key={g.value}
                                  value={g.value}
                                  control={<Radio />}
                                  label={g.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_name"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Member Name"
                          name="name"
                          value={memberdata?.name}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_email"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="email"
                          label="Member Email Id"
                          name="l_email"
                          value={memberdata?.l_email}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_contact_no"
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*"
                          }}
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          label="Member Contact No"
                          name="l_contact_no"
                          value={memberdata?.l_contact_no}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Member Password"
                          name="password"
                          value={memberdata?.password}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_name"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Name"
                          name="l_business_name"
                          value={memberdata?.l_business_name}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_description"
                          multiline
                          rows={3}
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Description"
                          name="l_business_description"
                          value={memberdata?.l_business_description}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_category"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Category"
                          name="l_business_category"
                          value={memberdata?.l_business_category}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>

                    {/* <Grid item xs={12}>
                      <label style={{ marginBottom: "10px" }}>
                        {step == 3 ? "Upload New Image If You Want " : "Upload User Profile Image"}
                      </label>
                      <br />
                      <Stack direction="row" alignItems={"center"} spacing={2}>
                        <Button
                          variant="contained"
                          component="label"
                          sx={{ height: 40 }}
                          style={{ marginTop: "10px" }}
                        >
                          Click To Upload File
                          <input
                            id="file"
                            name="file"
                            type="file"
                            hidden
                            onChange={(event) => {
                              setnewmemberdata({
                                ...memberdata,
                                photo: event.currentTarget.files[0]
                              });
                            }}
                            className="form-control"
                          />
                        </Button>
                      </Stack>
                    </Grid> */}
                  </Grid>
                </Stack>
                {/* </Card> */}
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setIsLoading_leadConvertMember_Btn(false);
                  setConvertMemberModal(false);
                  setnewmemberdata({
                    chpt_id: 0,
                    joining_date: moment().format("DD-MM-YYYY"),
                    due_date: moment().add(1, "years").format("DD-MM-YYYY"),
                    type: 0,
                    invite_by: 0,
                    gender: 0
                  });
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                disabled={isLoading_leadConvertMember_Btn}
                onClick={submitMemberForm}
              >
                Confirm{"  "}
                {isLoading_leadConvertMember_Btn && (
                  <CircularProgress size={14} style={{ marginLeft: "5px" }} />
                )}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={rejectmemberModal}
        onClose={() => setrejectmemberModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Reject Reason
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        {/* <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                        multiline
                          rows={5}
                          autoComplete="off"
                          type="text"
                          label="Reason"
                          name="member_renewal_reject_reason"
                          value={rejectReasonData?.member_renewal_reject_reason}
                          onChange={(e) => {
                            setRejectReasonData({
                              ...rejectReasonData,
                              member_renewal_reject_reason: e.target.value,
                            });
                          }}
                        /> */}
                        <label style={{ marginBottom: "10px" }}>Select Reject Reason</label>
                        <Select
                          value={
                            rejectReasonlist &&
                            rejectReasonlist
                              ?.map((p) => {
                                if (p.l_r_reason_id == rejectReasonData.l_r_reason_id) {
                                  return { value: p.l_r_reason_id, label: p.lead_reject_reason };
                                }
                              })
                              .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="l_r_reason_id"
                          onChange={(e) => {
                            setRejectReasonData({
                              ...rejectReasonData,
                              l_r_reason_id: e.value
                            });
                          }}
                          options={
                            !IsNotValue.includes(rejectReasonlist) &&
                            rejectReasonlist?.map((p) => {
                              return { value: p.l_r_reason_id, label: p.lead_reject_reason };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setrejectmemberModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitleadrejectreason}
                // disabled={isFormSubmit}
                disabled={isFormSubmit || isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      {/* Member Renewal Modal */}
      <Modal
        open={memberrenewalmodal}
        // onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...leadDetailsModelStyle }}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Member Renewal
          </Typography>
          <div style={{ padding: "10px" }}>
            <div
              style={{
                maxHeight: "420px",
                overflow: "scroll",
                padding: "10px"
              }}
            >
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                {/* <Card style={{ padding: "25px", paddingBottom: "25px" }}> */}
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <ChapterSelectDropDown
                          dropDownLabel={"Select Chapter"}
                          selectedState={memberrenewaldata}
                          chapterKey="chpt_id"
                          makeDisableSelect={true}
                        // handleChange={(e) => {
                        //   setFilter({ chpt_id: e.value });
                        //   getmemberbychp(e.value);
                        // }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Reference By</label>
                        <Select
                          isDisabled
                          value={
                            memberlist == null
                              ? { value: 0, label: "Reference By" }
                              : memberlist
                                ?.map((c) => {
                                  if (c.m_id == memberrenewaldata.reference_m_id) {
                                    return {
                                      value: c.m_id,
                                      label:
                                        c.m_name +
                                        " (" +
                                        c.business_name +
                                        ") [" +
                                        c.chpt_name +
                                        "]"
                                    };
                                  }
                                })
                                .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="invite_by"
                          options={
                            memberlist != null &&
                            memberlist?.map((chpt) => {
                              return {
                                value: chpt.m_id,
                                label:
                                  chpt.m_name +
                                  " (" +
                                  chpt.business_name +
                                  ") [" +
                                  chpt.chpt_name +
                                  "]"
                              };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>

                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
                        {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            disabled
                            type="date"
                            name="joindate"
                            label="Joining Date "
                            value={moment(memberrenewaldata.joining_date, "DD-MM-YYYY")}
                            inputFormat="dd/MM/yyyy"
                            onChange={(newDate) => { }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onKeyDown={
                                  loginUser.u_type == 1 ? (e) => e.preventDefault() : undefined
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            label="Expire Date "
                            name="expiredate"
                            value={moment(memberrenewaldata.newdue_date, "DD-MM-YYYY")}
                            inputFormat="dd/MM/yyyy"
                            {...(loginUser.u_type == 1
                              ? {
                                minDate: memberrenewaldata.minDate || null,
                                maxDate: memberrenewaldata.maxDate || null
                              }
                              : {})}
                            // {...(loginUser.u_type == 1
                            //   ? {
                            //       minDate: moment(memberrenewaldata.joining_date, "DD-MM-YYYY").toDate(),
                            //       maxDate: moment(memberrenewaldata.joining_date, "DD-MM-YYYY")
                            //         .add(1, "year")
                            //         .endOf("day")
                            //         .toDate()
                            //     }
                            //   : {})}
                            onChange={(newDate) => {
                              setmemberrenewaldata({
                                ...memberrenewaldata,
                                newdue_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onKeyDown={
                                  loginUser.u_type == 1 ? (e) => e.preventDefault() : undefined
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">Gender</FormLabel>

                        <RadioGroup
                          disabled={!memberrenewaldata?.gender == 0}
                          name="gender"
                          row // remove this if you want vertical
                          value={memberrenewaldata?.gender || 0}
                          onChange={(e) => {
                            setmemberrenewaldata({
                              ...memberrenewaldata,
                              gender: Number(e.target.value)
                            });
                          }}
                        >
                          {gender
                            .filter((g) => g.value !== 0) // remove "Select Gender"
                            .map((g) => (
                              <FormControlLabel
                                key={g.value}
                                value={g.value}
                                control={<Radio />}
                                label={g.label}
                              />
                            ))}
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_name"
                          disabled
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Member Name"
                          name="name"
                          value={memberrenewaldata?.m_name}
                        // onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_email"
                          disabled
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="email"
                          label="Member Email Id"
                          name="l_email"
                          value={memberrenewaldata?.m_email_id}
                        // onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_contact_no"
                          disabled
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*"
                          }}
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="number"
                          label="Member Contact No"
                          name="l_contact_no"
                          value={memberrenewaldata?.mobile_no}
                        // onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          disabled
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Member Password"
                          name="password"
                          value={memberrenewaldata?.password}
                        // onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_name"
                          disabled
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Name"
                          name="l_business_name"
                          value={memberrenewaldata?.business_name}
                        // onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_category"
                          disabled
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Category"
                          name="l_business_category"
                          value={memberrenewaldata?.business_category}
                        // onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_description"
                          multiline
                          rows={3}
                          disabled
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Description"
                          name="l_business_description"
                          value={memberrenewaldata?.l_business_description}
                        // onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
                {/* </Card> */}
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setmemberrenewalmodal(false);
                  setnewmemberdata({
                    chpt_id: 0,
                    joining_date: moment().format("DD-MM-YYYY"),
                    due_date: moment().add(1, "years").format("DD-MM-YYYY"),
                    type: 0,
                    invite_by: 0,
                    gender: 0
                  });
                  // setnewmemberdata({
                  //   joining_date: moment().format("DD-MM-YYYY"),
                  //   due_date: moment().add(1, "years").format("DD-MM-YYYY"),
                  //   type: 0,
                  //   invite_by: 0
                  // });
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitmemberrenewal}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Lead Change Modal */}
      {/* <Modal
        open={leadStatusChangeModal}
        onClose={closeLeadStatusChangeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Update Lead Status
          </Typography>
          <div style={{ padding: "10px" }}>
            {statusList?.map((status) => {
              return (
                <div
                  value={status?.value}
                  style={{
                    position: "relative",
                    marginBottom: "10px",
                    border:
                      leadStatusChangeData?.from_l_phase == status?.value
                        ? "none"
                        : "2px solid #1c4766",
                    padding: "7px 15px",
                    borderRadius: "10px",
                    background:
                      leadStatusChangeData?.from_l_phase == status?.value
                        ? "#1c4766"
                        : "#fff",
                    color:
                      leadStatusChangeData?.from_l_phase == status?.value
                        ? "#fff"
                        : "#000",
                    cursor: "pointer",
                    WebkitUserSelect: "none", // Optional: Disable text selection on double-click
                    MozUserSelect: "none", // Optional: Disable text selection on double-click
                    msUserSelect: "none", // Optional: Disable text selection on double-click
                    userSelect: "none", // Optional: Disable text selection on double-click
                  }}
                  onClick={async (e) => {
                    const divValue = e.currentTarget.getAttribute("value");
                    await leadStatusChange(
                      leadStatusChangeData.lead_id,
                      divValue,
                      leadStatusChangeData.from_l_phase
                    );

                    // if (divValue == leadStatusChangeData.from_l_phase) {

                    //   // Display Error
                    //   let notify = notification({
                    //     type: "error",
                    //     message: "Lead Status Not Updated",
                    //   });
                    //   notify();
                    // } else {
                    //   if (
                    //     ((leadStatusChangeData.from_l_phase == 4 &&
                    //       ((loginUser.p_user_id != 1 &&
                    //         loginUser.u_type == 2) ||
                    //         (loginUser.p_user_id == 1 &&
                    //           loginUser.u_type == 1) ||
                    //         (loginUser.p_user_id == 1 &&
                    //           loginUser.u_type == 2 &&
                    //           loginUser.management_p == 0 &&
                    //           loginUser.account_p == 0))) ||
                    //       ((leadStatusChangeData.from_l_phase == 5 ||
                    //         leadStatusChangeData.from_l_phase == 6) &&
                    //         loginUser.u_type == 2 &&
                    //         loginUser.management_p == 0 &&
                    //         loginUser.account_p == 0)) &&
                    //     loginUser.u_type != 0
                    //   ) {
                    //     let notify = notification({
                    //       type: "error",
                    //       message: "You don't have Permission ",
                    //     });
                    //     notify();
                    //   } else if (
                    //     ((divValue == 5 &&
                    //       ((loginUser.p_user_id != 1 &&
                    //         loginUser.u_type == 2) ||
                    //         (loginUser.p_user_id == 1 &&
                    //           loginUser.u_type == 1) ||
                    //         (loginUser.p_user_id == 1 &&
                    //           loginUser.u_type == 2 &&
                    //           loginUser.management_p == 0 &&
                    //           loginUser.account_p == 0))) ||
                    //       (divValue == 6 &&
                    //         loginUser.u_type == 2 &&
                    //         loginUser.management_p == 0)) &&
                    //     loginUser.u_type != 0
                    //   ) {
                    //     let notify = notification({
                    //       type: "error",
                    //       message: "You don't have Permission ",
                    //     });
                    //     notify();
                    //   } else if (
                    //     leadStatusChangeData.from_l_phase == 6 &&
                    //     (loginUser.u_type == 0 ||
                    //       loginUser.u_type == 1 ||
                    //       (loginUser.u_type == 2 &&
                    //         loginUser.management_p == 1))
                    //   ) {
                    //   } else {
                    //     // update the Status
                    //     let lfdata = new FormData();
                    //     lfdata.append("lead_id", leadStatusChangeData.lead_id);
                    //     lfdata.append("l_phase", divValue);
                    //     lfdata.append("u_id", leadStatusChangeData.u_id);
                    //     lfdata.append(
                    //       "from_l_phase",
                    //       leadStatusChangeData.from_l_phase
                    //     );
                    //     const resp = await updateleadstatus(lfdata);
                    //     let notify = notification({
                    //       type: resp.status == 0 ? "error" : "success",
                    //       message: resp.message,
                    //     });
                    //     notify();
                    //     if (resp.status == 1) {
                    //       closeLeadStatusChangeModal();

                    //       // Visitor / Inquiry Lead API CALL
                    //       setNewLan(initNewLan);
                    //       await getAllPhaseLeads();
                    //       // await getleadlist();
                    //     }
                    //   }
                    // }
                  }}
                >
                  <a id="">{status.label}</a>
                  {leadStatusChangeData?.from_l_phase == status?.value && (
                    <Check
                      color="#fff"
                      style={{ position: "absolute", right: "10" }}
                    />
                  )}
                </div>
              );
            })}
            <hr />

            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button variant="outlined" onClick={closeLeadStatusChangeModal}>
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal> */}
      <Modal
        open={leadStatusChangeModal}
        onClose={closeLeadStatusChangeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={leadFollowupStyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Update Lead Status
          </Typography>
          <div style={{ padding: "10px" }}>
            {statusList?.map((status) => {
              const currentPhase = leadStatusChangeData?.from_l_phase;
              const currentType = leadStatusChangeData?.l_type;
              const targetPhase = status?.a_id;

              // Block: Member Renewal → Visitor/Inquiry
              // Block: Visitor/Inquiry → Member Renewal
              const isDisabled = (() => {
                if (currentType == 3 && currentPhase == 7 && targetPhase !== 8) return true; // Block any Member Renewal → Visitor/Inquiry
                if (currentType == 2 && targetPhase == 1) return true; // Block any Member Renewal → Visitor/Inquiry
                if ((currentType == 0 || currentType == 1) && targetPhase == 2) return true; // Block any Visitor/Inquiry → Member Renewal
                if (currentPhase == 1 && (currentType == 0 || currentType == 1) && targetPhase == 2)
                  return true; // Block Visitor → Inquiry
                if (
                  currentPhase == 5 &&
                  (targetPhase == 1 ||
                    targetPhase == 2 ||
                    targetPhase == 4 ||
                    targetPhase == 5 ||
                    targetPhase == 7)
                )
                  return true; // Block Waiting For Payment -> Visitor/Member Renewal/Confirm/Waiting For Payment/Give App Access
                if (
                  currentPhase == 6 &&
                  (targetPhase == 1 ||
                    targetPhase == 2 ||
                    targetPhase == 4 ||
                    targetPhase == 5 ||
                    targetPhase == 6)
                )
                  return true; // Block Payment Verified -> Visitor/Member Renewal/Confirm/Waiting For Payment/Payment Verified"
                if (currentPhase != 2 && targetPhase == 10) return true; // Block any status → Member Deactivated except from Member Renewal
                return false;
              })();

              return (
                <div
                  value={status?.a_id}
                  style={{
                    position: "relative",
                    marginBottom: "10px",
                    border:
                      currentPhase === status?.a_id
                        ? "none"
                        : isDisabled
                          ? "2px dashed gray"
                          : "2px solid #1c4766",
                    padding: "7px 15px",
                    borderRadius: "10px",
                    background:
                      currentPhase === status?.a_id ? "#1c4766" : isDisabled ? "#f5f5f5" : "#fff",
                    color: currentPhase === status?.a_id ? "#fff" : isDisabled ? "#aaa" : "#000",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    pointerEvents: isDisabled ? "none" : "auto",
                    WebkitUserSelect: "none", // Optional: Disable text selection on double-click
                    MozUserSelect: "none", // Optional: Disable text selection on double-click
                    msUserSelect: "none", // Optional: Disable text selection on double-click
                    userSelect: "none" // Optional: Disable text selection on double-click
                  }}
                  onClick={async (e) => {
                    const divValue = e.currentTarget.getAttribute("value");

                    if (divValue == 6 && (loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 1))) {
                      setInvoiceAmountVerifiedData({
                        lead_id: leadStatusChangeData.lead_id,
                        divValue: divValue,
                        from_l_phase: leadStatusChangeData.from_l_phase,
                        l_allocated_to: leadStatusChangeData.l_allocated_to
                      });
                      toggleInvoiceAmountVerifiedModal();
                    } else {
                      await leadStatusChange(
                        leadStatusChangeData.lead_id,
                        divValue,
                        leadStatusChangeData.from_l_phase
                      );
                    }
                  }}
                >
                  <a id="">{status.name}</a>
                  {currentPhase === status?.a_id && (
                    <Check color="#fff" style={{ position: "absolute", right: "10" }} />
                  )}
                </div>
              );
            })}
            <hr />

            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button variant="outlined" onClick={closeLeadStatusChangeModal}>
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Page title="Lead | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Lead
            </Typography>
          </Stack>
          {step == 1 ? (
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  setformdata({ l_created_by: loginUser.u_id, l_type: 0, gender: 0 });
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card
                style={{
                  padding: "25px",
                  paddingBottom: "25px",
                  marginBottom: "25px"
                }}
              >
                Add New Lead
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    {step != 2 && (
                      <>
                        <Grid item xs={6}>
                          <Stack spacing={10} style={{ marginBottom: "15px" }}>
                            <label style={{ marginBottom: "10px" }}>Allocate To</label>
                            <Select
                              value={
                                allocatelist &&
                                allocatelist
                                  ?.map((p) => {
                                    if (p.u_id == formdata.l_allocated_to) {
                                      return { value: p.u_id, label: p.u_name };
                                    }
                                  })
                                  .filter((n) => n)[0]
                              }
                              style={{ marginTop: "0px" }}
                              name="l_allocated_to"
                              onChange={(e) => {
                                setformdata({
                                  ...formdata,
                                  l_allocated_to: e.value
                                });
                              }}
                              options={
                                allocatelist != null &&
                                allocatelist?.map((p) => {
                                  return { value: p.u_id, label: p.u_name };
                                })
                              }
                            ></Select>
                          </Stack>
                        </Grid>
                        <Grid item xs={6}>
                          <Stack spacing={10} style={{ marginBottom: "15px" }}>
                            <label style={{ marginBottom: "10px" }}>Status</label>

                            <Select
                              isDisabled={statusList.length === 0}
                              placeholder={
                                statusList.length === 0 ? "Loading status..." : "Select status"
                              }
                              value={formdata.l_phase}
                              name="l_phase"
                              onChange={(e) => {
                                setformdata({ ...formdata, l_phase: e.a_id });
                              }}
                              options={statusList?.filter((p) => p.a_id != 2 && p.a_id != 10)}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.a_id}
                            />
                          </Stack>
                          {/* <Stack spacing={10} style={{ marginBottom: "15px" }}>
                            <label style={{ marginBottom: "10px" }}>Status</label>
                            <Select
                              value={
                                statusList &&
                                statusList
                                  ?.filter((p) => p.a_id != 1)
                                  ?.map((p) => {
                                    if (p.a_id == formdata.l_phase) {
                                      return { value: p.a_id, label: p.name };
                                    }
                                  })
                                  .filter((n) => n)[0]
                              }
                              style={{ marginTop: "0px" }}
                              name="l_phase"
                              onChange={(e) => {
                                setformdata({ ...formdata, l_phase: e.value });
                              }}
                              options={statusList?.filter((p) => p.a_id != 1)}
                            ></Select>
                          </Stack> */}
                        </Grid>
                      </>
                    )}
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Gender</FormLabel>

                          <RadioGroup
                            name="gender"
                            row // remove this if you want vertical
                            value={formdata.gender || 0}
                            onChange={onChangeFunction}
                          >
                            {gender
                              .filter((g) => g.value !== 0) // remove "Select Gender"
                              .map((g) => (
                                <FormControlLabel
                                  key={g.value}
                                  value={g.value}
                                  control={<Radio />}
                                  label={g.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_name"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Name"
                          name="name"
                          value={formdata?.name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_email"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="email"
                          label="Email"
                          name="l_email"
                          value={formdata?.l_email}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_contact_no"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Contact No"
                          name="l_contact_no"
                          value={formdata?.l_contact_no}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_address"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Address"
                          name="l_address"
                          value={formdata?.l_address}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_name"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Name"
                          name="l_business_name"
                          value={formdata?.l_business_name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_description"
                          multiline
                          rows={3}
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Description"
                          name="l_business_description"
                          value={formdata?.l_business_description}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_business_category"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Category"
                          name="l_business_category"
                          value={formdata?.l_business_category}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LimitedTextField
                          limitKey="lead_gst_no"
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="GST No"
                          name="gst_no"
                          value={formdata?.gst_no}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            disableFuture
                            type="date"
                            name="date"
                            label="Date"
                            inputFormat="dd/MM/yyyy"
                            value={moment(formdata.date, "DD-MM-YYYY")}
                            onChange={(newDate) => {
                              const formattedDate = moment(newDate)
                                .set({
                                  hour: moment().hour(),
                                  minute: moment().minute(),
                                  second: 0,
                                  millisecond: 0
                                })
                                .format("DD-MM-YYYY HH:mm");
                              setformdata({
                                ...formdata,
                                date: formattedDate
                              });
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={submitformdata}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Save
                </Button>
                {/* <Button style={{ marginTop: "15px" }} variant="contained" onClick={submitformdata}>
                  Save
                </Button> */}
              </Card>
            </>
          ) : step == 2 ? (
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  setformdata({ l_created_by: loginUser.u_id, l_type: 0, gender: 0 });
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card className="p-20">
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={activeTab}
                    variant="fullWidth"
                    allowScrollButtonsMobile
                    onChange={
                      (e, value) => {
                        // checkValidation(value);
                        setActiveTab(value);
                      }
                      // setMemberDetailData([]),
                      // setActiveTab(value),
                      // getMembersDetailReport(value, activeRow.m_id)
                    }
                  >
                    <Tab
                      className="mb-0 pb-0"
                      disableRipple
                      key={1}
                      value={1}
                      label="Personal / Business Details"
                      icon={<Person />}
                      iconPosition="start"
                    />
                    {/* <Tab
                      className="mb-0 pb-0"
                      disableRipple
                      key={2}
                      value={2}
                      label="Business Details"
                      icon={<Business />}
                      iconPosition="start"
                    /> */}
                  </Tabs>
                </Box>
                <Grid container spacing={2} className="mt-10">
                  {activeTab == 1 ? (
                    <>
                      <Grid item xs={6}>
                        <Stack spacing={10} style={{ marginBottom: "15px" }}>
                          <FormControl component="fieldset">
                            <FormLabel component="legend">Gender</FormLabel>

                            <RadioGroup
                              name="gender"
                              row // remove this if you want vertical
                              value={formdata.gender || 0}
                              onChange={onChangeFunction}
                            >
                              {gender
                                .filter((g) => g.value !== 0) // remove "Select Gender"
                                .map((g) => (
                                  <FormControlLabel
                                    key={g.value}
                                    value={g.value}
                                    control={<Radio />}
                                    label={g.label}
                                  />
                                ))}
                            </RadioGroup>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_name"
                            style={{ marginTop: "0px" }}
                            fullWidth
                            required
                            autoComplete="off"
                            type="text"
                            label="Full Name"
                            name="name"
                            value={formdata?.name}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_contact_no"
                            fullWidth
                            required
                            autoComplete="off"
                            type="text"
                            label="Contact Number"
                            name="l_contact_no"
                            value={formdata?.l_contact_no}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_business_name"
                            fullWidth
                            autoComplete="off"
                            autoCorrect="off"
                            type="text"
                            required
                            label="Company Name"
                            name="l_business_name"
                            value={formdata?.l_business_name || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid>

                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_business_category"
                            fullWidth
                            required
                            autoComplete="off"
                            autoCorrect="off"
                            type="text"
                            label="Business Category"
                            name="l_business_category"
                            value={formdata?.l_business_category || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_email"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            required
                            label="Email ID"
                            name="l_email"
                            value={formdata?.l_email || ""}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      {/* <Grid item xs={6} className="mb-15">
                        <Stack spacing={10}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              type="date"
                              name="dob"
                              label="Date of Birth"
                              value={
                                formdata?.dob != undefined
                                  ? moment(formdata.dob, "DD-MM-YYYY")
                                  : null
                              }
                              disableFuture
                              inputFormat="dd/MM/yyyy"
                              onChange={(newDate) => {
                                setformdata({
                                  ...formdata,
                                  dob: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                });
                              }}
                              renderInput={(params) => <TextField {...params} required />}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid> */}

                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_alt_contact_no"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            label="Alternate Contact Number"
                            name="alternate_contact_number"
                            value={formdata?.alternate_contact_number}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl>
                            <FormLabel id="demo-error-radios" className="font-bold">
                              Please Select Insurance you have
                              <span
                                aria-hidden="true"
                                className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>
                            <FormGroup name="insuranceType">
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={1}
                                control={
                                  <Checkbox
                                    checked={formdata?.insuranceType?.includes("1")}
                                    name="Health_Insurance"
                                  />
                                }
                                label="Health Insurance"
                              />
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={2}
                                control={
                                  <Checkbox
                                    name="Life_Insurance"
                                    checked={formdata?.insuranceType?.includes("2")}
                                  />
                                }
                                label="Life Insurance"
                              />
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={3}
                                control={
                                  <Checkbox
                                    name="Term_Insurance"
                                    checked={formdata?.insuranceType?.includes("3")}
                                  />
                                }
                                label="Term Insurance"
                              />
                              <FormControlLabel
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                value={4}
                                control={
                                  <Checkbox
                                    name="None"
                                    checked={formdata?.insuranceType?.includes("4")}
                                  />
                                }
                                label="None"
                              />
                              <FormControlLabel
                                value={0}
                                onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                control={
                                  <Checkbox
                                    name="Other"
                                    checked={formdata?.insuranceType?.includes("0")}
                                  />
                                }
                                label="Other"
                              />

                              {formdata?.insuranceType?.includes("0") && (
                                <LimitedTextField
                                  limitKey="lead_other_insurance"
                                  // label="Other Option"
                                  variant="standard"
                                  fullWidth
                                  autoComplete="off"
                                  autoCorrect="off"
                                  name="otherInsurance"
                                  placeholder="Other Insurance"
                                  value={formdata?.otherInsurance}
                                  onChange={onChangeFunction}
                                />
                              )}
                            </FormGroup>
                          </FormControl>
                        </Stack>
                      </Grid> */}
                      <Grid item xs={6}>
                        <Stack spacing={3} style={{ marginBottom: "15px" }}>
                          <LimitedTextField
                            limitKey="lead_business_description"
                            multiline
                            rows={3}
                            style={{ marginTop: "0px" }}
                            fullWidth
                            autoComplete="off"
                            type="text"
                            label="Business Description"
                            name="l_business_description"
                            value={formdata?.l_business_description}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid>
                      {formdata?.l_type != 2 && (
                        <Grid item xs={12} md={12} className="mb-15">
                          <Stack spacing={10}>
                            <FormControl variant="standard">
                              <FormLabel id="demo-error-radios" className="label-bold">
                                Select Aadhaar Card Front & Back Photo{" "}
                                <span
                                  aria-hidden="true"
                                  className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                                >
                                  *
                                </span>
                              </FormLabel>
                              <div>
                                <label className="file-label" htmlFor="file">
                                  <Label
                                    variant="filled"
                                    color={undefined}
                                    className="select-file-label"
                                  >
                                    <div className="select-file-label-text">
                                      Select File
                                      <AddPhotoAlternate className="select-file-label-icon" />
                                    </div>
                                  </Label>
                                  <input
                                    id="file"
                                    type="file"
                                    hidden
                                    name="aadhaar"
                                    accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.bmp"
                                    onChange={(e) => {
                                      handleFileChange(e, "aadhaar");
                                    }}

                                  // onBlur={checkValidation}
                                  />
                                </label>
                                <div>
                                  <>
                                    {formdata?.aadhaar && (
                                      <div>
                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                          <Box
                                            sx={{
                                              // mt: 1,
                                              width: "40%",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                              border: "1px solid #e0e0e0",
                                              borderRadius: 1

                                              // p: 1
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                flex: 1,
                                                minWidth: 0
                                              }}
                                            >
                                              <Box sx={{ ml: 1, minWidth: 0 }}>
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                  }}
                                                >
                                                  {formdata?.aadhaar?.name || formdata?.aadhaar}
                                                </Typography>
                                              </Box>
                                            </Box>

                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "1px",
                                                flexShrink: 0
                                              }}
                                            >
                                              <Button
                                                size="small"
                                                onClick={() => {
                                                  const file = formdata?.aadhaar;
                                                  const url = formdata?.aadhaar;

                                                  if (file instanceof File) {
                                                    const fileURL = URL.createObjectURL(file);
                                                    window.open(fileURL, "_blank");
                                                  } else if (url) {
                                                    window.open(
                                                      `${Routes.API_HOSTNAME}images/leadMemberAadhaar/${url}`,
                                                      "_blank"
                                                    );
                                                  }
                                                }}
                                              >
                                                <VisibilityIcon fontSize="small" />
                                              </Button>
                                              <Button
                                                size="small"
                                                color="error"
                                                onClick={() =>
                                                  deleteLeadAttachmentHandler(
                                                    formdata?.lead_id,
                                                    "aadhaar",
                                                    formdata?.aadhaar
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </div>
                                    )}

                                    {/* Input Helper */}
                                    {/* <Label variant={"ghost"} color="error" className="warning-note">
                                      More Then 10MB of File Are Not Supported
                                    </Label> */}

                                    <Label variant={"ghost"} color="primary" className="warning-note">
                                      Note: PDF, Doc & Images are Only Supported
                                    </Label>
                                  </>
                                </div>
                              </div>
                            </FormControl>
                          </Stack>
                        </Grid>
                      )}
                      <Grid item xs={12} md={12} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_gst_no"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            label="GST No"
                            name="gst_no"
                            value={formdata?.gst_no || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid>

                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_other_group_name"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            label="Other Networking Platform"
                            name="other_group_name"
                            placeholder="Have you join any Other Networking Platform"
                            value={formdata?.other_group_name || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid> */}
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_address"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            required
                            label="Office Address"
                            name="l_address"
                            value={formdata?.l_address || ""}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid> */}
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_h_address"
                            fullWidth
                            autoComplete="off"
                            type="text"
                            required
                            label="Home Address"
                            name="l_h_address"
                            value={formdata?.l_h_address || ""}
                            onChange={onChangeFunction}
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid> */}
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              type="date"
                              name="payment_date"
                              label="Payment Date"
                              value={
                                formdata?.payment_date != undefined
                                  ? moment(formdata.payment_date, "DD-MM-YYYY")
                                  : null
                              }
                              inputFormat="dd/MM/yyyy"
                              onChange={(newDate) => {
                                setformdata({
                                  ...formdata,
                                  payment_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // disabled
                                  {...params}
                                  required
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl>
                            <FormLabel id="demo-error-radios" className="font-bold">
                              Please Select Payment Method{" "}
                              <span
                                aria-hidden="true"
                                className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>

                            <RadioGroup
                              row // display as Row
                              name="payment_mode"
                              value={formdata?.payment_mode}
                              required
                              onChange={(e) => {
                                setformdata({
                                  ...formdata,
                                  payment_mode: e.target.value
                                });
                              }}
                            >
                              <FormControlLabel value={0} control={<Radio />} label="Cash" />
                              <FormControlLabel value={1} control={<Radio />} label="Transfer" />
                              <FormControlLabel value={2} control={<Radio />} label="Cheque" />
                            </RadioGroup>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <FormControl variant="standard">
                            <FormLabel id="demo-error-radios" className="font-bold">
                              Upload Payment Screenshot / Cheque Photo{" "}
                              <span
                                aria-hidden="true"
                                class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                              >
                                *
                              </span>
                            </FormLabel>
                            <div>
                              <label htmlFor="payment_photo" className="file-label">
                                <Label
                                  variant="filled"
                                  color={undefined}
                                  className="select-file-label"
                                >
                                  <div className="select-file-label-text">
                                    Select File
                                    <AddPhotoAlternate className="select-file-label-icon" />
                                  </div>
                                </Label>
                                <input
                                  id="payment_photo"
                                  type="file"
                                  hidden
                                  multiple
                                  name="l_payment_photo"
                                  accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.bmp"
                                  onChange={(e) => {
                                    handleFileChange(e, "l_payment_photo");
                                  }}
                                />
                              </label>
                              <div className="mt-1">
                                <>
                                  {/* {formdata?.l_payment_photo && (
                                    <div
                                      variant={"ghost"}
                                      color="success"
                                      className="upload-file-name"
                                    >
                                      Productphoto.png
                                      {formdata?.l_payment_photo?.name || formdata?.l_payment_photo}
                                    </div>
                                  )} */}

                                  {
                                    Array.isArray(formdata?.l_payment_photo) &&
                                    formdata?.l_payment_photo.map((file, index) => (
                                      <div>
                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                          <Box
                                            sx={{
                                              mt: 1,
                                              width: "80%",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                              border: "1px solid #e0e0e0",
                                              borderRadius: 1
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                flex: 1,
                                                minWidth: 0
                                              }}
                                            >
                                              <Box sx={{ ml: 1, minWidth: 0 }}>
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                  }}
                                                >
                                                  {file?.name || file}
                                                </Typography>
                                              </Box>
                                            </Box>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "1px",
                                                flexShrink: 0
                                              }}
                                            >
                                              <Button
                                                size="small"
                                                onClick={() => {
                                                  const url = file;

                                                  if (file instanceof File) {
                                                    const fileURL = URL.createObjectURL(file);
                                                    window.open(fileURL, "_blank");
                                                  } else if (url) {
                                                    window.open(
                                                      `${Routes.API_HOSTNAME}images/leadMemberPayment/${url}`,
                                                      "_blank"
                                                    );
                                                  }
                                                }}
                                              >
                                                <VisibilityIcon fontSize="small" />
                                              </Button>
                                              <Button
                                                size="small"
                                                color="error"
                                                onClick={() =>
                                                  deleteLeadAttachmentHandler(
                                                    formdata?.lead_id,
                                                    "l_payment_photo",
                                                    file,

                                                    formdata.l_payment_photo_id[index],
                                                    index
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </div>
                                    ))
                                    // : formdata?.l_payment_photo && (
                                    //     <div
                                    //       variant={"ghost"}
                                    //       color="success"
                                    //       className="upload-file-name"
                                    //     >
                                    //       {formdata?.l_payment_photo?.name ||
                                    //         formdata?.l_payment_photo}
                                    //     </div>
                                    //   )
                                  }

                                  {/* <div
                                  style={{
                                    marginTop: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <FormHelperText>
                                    {errors.l_product_photo}
                                  </FormHelperText>
                                </div> */}

                                  {/* <Label variant={"ghost"} color="error" className="warning-note">
                                    More Then 10MB of File Are Not Supported
                                  </Label> */}
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center"
                                    }}
                                  >
                                    <Label
                                      variant={"ghost"}
                                      color="primary"
                                      style={{
                                        margin: "0",
                                        display: "flex",
                                        marginTop: "10px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "fit-content",
                                        paddingBottom: "5px",
                                        paddingTop: "5px",
                                        fontSize: "14px"
                                      }}
                                    >
                                      Note: PDF, Doc & Images are Only Supported
                                    </Label>
                                  </div>
                                </>
                              </div>
                            </div>
                          </FormControl>
                        </Stack>
                      </Grid>
                      {formdata?.l_type != 2 && (
                        <Grid item xs={12} md={6} className="mb-15">
                          <Stack spacing={10}>
                            <FormControl variant="standard">
                              <FormLabel id="demo-error-radios" className="font-bold">
                                Upload Professional Photo{" "}
                                <span
                                  aria-hidden="true"
                                  class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                                >
                                  *
                                </span>
                              </FormLabel>
                              <div>
                                <label className="file-label" htmlFor="l_professional_photo">
                                  <Label
                                    variant="filled"
                                    color={undefined}
                                    className="select-file-label"
                                  >
                                    <div className="select-file-label-text">
                                      Select File
                                      <AddPhotoAlternate className="select-file-label-icon" />
                                    </div>
                                  </Label>
                                  <input
                                    id="l_professional_photo"
                                    type="file"
                                    hidden
                                    name="l_professional_photo"
                                    accept=".jpeg,.jpg,.png,.gif"
                                    onChange={(e) => handleFileChange(e, "l_professional_photo")}
                                  />
                                </label>
                                <div>
                                  <>
                                    {formdata?.l_professional_photo && (
                                      <div>
                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                          <Box
                                            sx={{
                                              mt: 1,
                                              width: "80%",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                              border: "1px solid #e0e0e0",
                                              borderRadius: 1
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                flex: 1,
                                                minWidth: 0
                                              }}
                                            >
                                              <Box sx={{ ml: 1, minWidth: 0 }}>
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                  }}
                                                >
                                                  {formdata?.l_professional_photo?.name ||
                                                    formdata?.l_professional_photo}
                                                </Typography>
                                              </Box>
                                            </Box>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "1px",
                                                flexShrink: 0
                                              }}
                                            >
                                              <Button
                                                size="small"
                                                onClick={() => {
                                                  const url = formdata?.l_professional_photo;

                                                  if (url instanceof File) {
                                                    const fileURL = URL.createObjectURL(url);
                                                    window.open(fileURL, "_blank");
                                                  } else if (url) {
                                                    window.open(
                                                      `${Routes.API_HOSTNAME}images/leadMemberProfile/${url}`,
                                                      "_blank"
                                                    );
                                                  }
                                                }}
                                              >
                                                <VisibilityIcon fontSize="small" />
                                              </Button>
                                              <Button
                                                size="small"
                                                color="error"
                                                onClick={() =>
                                                  deleteLeadAttachmentHandler(
                                                    formdata?.lead_id,
                                                    "l_professional_photo",
                                                    formdata?.l_professional_photo
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </div>
                                    )}
                                    {/* <Label variant={"ghost"} color="error" className="warning-note">
                                      More Then 10MB of File Are Not Supported
                                    </Label> */}
                                    <Label variant={"ghost"} color="primary" className="warning-note">
                                      Note: Only Image Supported
                                    </Label>
                                  </>
                                </div>
                              </div>
                            </FormControl>
                          </Stack>
                        </Grid>
                      )}
                      {formdata?.l_type != 2 && (
                        <>
                          <Grid item xs={12} md={6} className="mb-15">
                            <Stack spacing={10}>
                              <LimitedTextField
                                limitKey="lead_reference"
                                fullWidth
                                required
                                autoComplete="off"
                                type="text"
                                label="Reference By (1)"
                                name="l_reference_1"
                                value={formdata?.l_reference_1}
                                onChange={onChangeFunction}
                                autoCorrect="off"
                              />
                            </Stack>
                          </Grid>

                          <Grid item xs={12} md={6} className="mb-15">
                            <Stack spacing={10}>
                              <LimitedTextField
                                limitKey="lead_reference"
                                fullWidth
                                required
                                autoComplete="off"
                                type="text"
                                label="Reference By (2)"
                                name="l_reference_2"
                                value={formdata?.l_reference_2}
                                onChange={onChangeFunction}
                                autoCorrect="off"
                              />
                            </Stack>
                          </Grid>
                        </>
                      )}
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <TextField
                            fullWidth
                            type="text"
                            label="Enter Facebook ID"
                            name="facebook_url"
                            value={formdata?.facebook_url || ""}
                            onChange={onChangeFunction}
                            autoComplete="off"
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <TextField
                            fullWidth
                            type="text"
                            label="Enter Instagram ID"
                            name="instagram_url"
                            value={formdata?.instagram_url || ""}
                            onChange={onChangeFunction}
                            autoComplete="off"
                            autoCorrect="off"
                          />
                        </Stack>
                      </Grid> */}
                    </>
                  ) : (
                    <>
                      {/* <Grid item xs={12} md={6} className="mb-15">
                        <Stack spacing={10}>
                          <LimitedTextField
                            limitKey="lead_business_description"
                            multiline
                            rows={3}
                            fullWidth
                            autoComplete="off"
                            autoCorrect="off"
                            type="text"
                            label="Business Description"
                            name="l_business_description"
                            value={formdata?.l_business_description || ""}
                            onChange={onChangeFunction}
                          />
                        </Stack>
                      </Grid> */}
                    </>
                  )}
                </Grid>
                {/* Submit and next , back handle */}
                <div className="edit-lead-form-footer">
                  {/* {activeTab == 1 && (
                    <Button
                      variant="contained"
                      className="my-auto mx-5"
                      // onClick={async (e) => {
                      //   // checkValidation();
                      // }}
                      onClick={() => setActiveTab(2)}
                    >
                      Next
                    </Button>
                  )} */}

                  {/* {activeTab == 2 && (
                    <>
                      <Button
                        variant="outlined"
                        className="my-auto mx-5"
                        onClick={() => setActiveTab(1)}
                      >
                        Back
                      </Button> */}
                  <Button
                    variant="contained"
                    className="my-auto mx-5"
                    // onClick={async () => {
                    //   checkValidation(1);
                    //   checkValidation(2);
                    // }}
                    disabled={isLoading}
                    onClick={submitformdata}
                  >
                    Submit
                    {isLoading && (
                      <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                    )}
                  </Button>
                  {/* </>
                  )} */}
                </div>
              </Card>
            </>
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  onClick={() => {
                    setStep(1);
                  }}
                  style={{ marginBottom: "15px" }}
                  variant="contained"
                >
                  Add Lead
                </Button>
                {/* <Button
                  onClick={() => {
                    step == 0 ? setStep(3) : setStep(0);
                  }}
                  style={{ marginBottom: "15px" }}
                  variant="contained"
                >
                  {step == 0 ? "Table View" : "Card View"}
                </Button> */}
                <Button
                  className="btn btn-export"
                  style={{ marginBottom: "15px", marginTop: "0" }}
                  variant="contained"
                  onClick={exportFilteredLead}
                  // disabled={loading}
                  disabled={isLoading || loading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  {loading ? "Exporting..." : "Export CSV"}
                </Button>
              </div>
              <Card className="p-20">
                {/* <Grid container spacing={2}> */}
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <TextField
                        fullWidth
                        value={filterlead?.filterl}
                        autoComplete="off"
                        type="text"
                        size="small"
                        label="Search Lead"
                        name="search"
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            filterl: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="s_date"
                          label="Start Date "
                          inputFormat="dd/MM/yyyy"
                          value={
                            filterlead.s_date != null
                              ? moment(filterlead.s_date, "DD-MM-YYYY")
                              : null
                          }
                          onChange={(newDate) => {
                            setfilterlead({
                              ...filterlead,
                              s_date: newDate
                                ? moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                : null
                            });
                          }}
                          renderInput={(params) => <TextField {...params} size="small" />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="e_date"
                          label="End Date "
                          inputFormat="dd/MM/yyyy"
                          value={
                            filterlead.e_date != null
                              ? moment(filterlead.e_date, "DD-MM-YYYY")
                              : null
                          }
                          // onChange={setnewformdata}
                          onChange={(newDate) => {
                            setfilterlead({
                              ...filterlead,
                              e_date: newDate
                                ? moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                : null
                            });
                          }}
                          renderInput={(params) => <TextField {...params} size="small" />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  {(loginUser?.u_type == 0 ||
                    (loginUser?.u_type == 0 && loginUser?.is_subadmin == 1)) && (
                      <Grid item xs={3}>
                        <Stack spacing={3}>
                          <label>Select City</label>
                          <Select
                            isDisabled={
                              loginUser?.u_type == 1 ||
                                (loginUser?.u_type == 2 &&
                                  loginUser?.p_user_id != 1 &&
                                  loginUser?.management_p == 1)
                                ? true
                                : false
                            }
                            value={
                              filterlead.filterCity == 0
                                ? {
                                  value: 0,
                                  label: "All City"
                                }
                                : allCityList.map((city) => {
                                  return (
                                    filterlead.filterCity == city.city_id && {
                                      value: city.city_id,
                                      label: city.city_name
                                    }
                                  );
                                })
                            }
                            onChange={(e) => {
                              setfilterlead({
                                ...filterlead,
                                filterCity: e.value,
                                filterchap: 0
                              });
                            }}
                            options={[
                              {
                                value: 0,
                                label: "All City"
                              },
                              ...allCityList.map((city) => {
                                return {
                                  label: city?.city_name,
                                  value: city?.city_id
                                };
                              })
                            ]}
                            menuPortalTarget={document.body}
                          />
                        </Stack>
                      </Grid>
                    )}

                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <label>Select User</label>
                      <Select
                        value={filterOption?.map((st) => {
                          if (st.value == filterlead.filteruser) {
                            return { value: st.value, label: st.label };
                          }
                        })}
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            filteruser: e.value,
                            selected_subadmin: e.is_subadmin,
                            parent_user_id: e.p_user_id
                          });
                        }}
                        options={filterOption}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <label>Select Lead Status</label>
                      <Select
                        //filter.lead_status
                        value={
                          filterlead.lead_status == -1
                            ? { value: -1, label: "All Lead" }
                            : statusList?.map((st) => {
                              if (st.a_id == filterlead.lead_status) {
                                return { value: st.a_id, label: st.name };
                              }
                            })
                        }
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            lead_status: e.value
                          });
                        }}
                        options={[
                          { value: -1, label: "All Lead" },
                          ...statusList.map((st) => ({
                            value: st.a_id,
                            label: st.name
                          }))
                        ]}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <label>Select Lead Type</label>
                      <Select
                        value={LeadSearchTypeOptions?.map((st) => {
                          if (st.value == filterlead.lead_type) {
                            return { value: st.value, label: st.label };
                          }
                        })}
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({ ...filterlead, lead_type: e.value });
                        }}
                        options={LeadSearchTypeOptions}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3}>
                      <label>Select Invoice Type</label>
                      <Select
                        value={invoiceTypeFilter?.map((option) => {
                          if (option.value == filterlead.invoice_generated_filter) {
                            return { value: option.value, label: option.label };
                          }
                        })}
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({ ...filterlead, invoice_generated_filter: e.value });
                        }}
                        options={invoiceTypeFilter}
                      />
                    </Stack>
                  </Grid>

                  {/* <Grid item xs={3}></Grid> */}
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end"
                      }}
                    >
                      <Button
                        onClick={() => {
                          setLoadingMoreData(-1);
                          getFilterLeadData();
                        }}
                        variant="contained"
                        sx={{ marginRight: "10px" }}
                      >
                        search
                      </Button>
                      <Button
                        onClick={async () => {
                          await setLoadingMoreData(-1);

                          await setfilterlead({
                            u_id: loginUser.u_id,
                            u_type: loginUser.u_type,
                            filterl: "",
                            s_date: null,
                            e_date: null,
                            filteruser: 0,
                            l_phase: -1,
                            lead_status: -1,
                            lead_type: -1,
                            invoice_generated_filter: -1,
                            filterCity:
                              loginUser?.u_type == 1 ||
                                (loginUser?.u_type == 2 &&
                                  loginUser?.p_user_id != 1 &&
                                  loginUser?.management_p == 1)
                                ? loginUser?.city_id
                                : location.state?.city || 0
                          });
                          await resetSearchForm({
                            u_id: loginUser.u_id,
                            u_type: loginUser.u_type,
                            filterl: "",
                            s_date: null,
                            e_date: null,
                            filteruser: 0,
                            l_phase: -1,
                            lead_status: -1,
                            lead_type: -1,
                            invoice_generated_filter: -1,
                            filterCity:
                              loginUser?.u_type == 1 ||
                                (loginUser?.u_type == 2 &&
                                  loginUser?.p_user_id != 1 &&
                                  loginUser?.management_p == 1)
                                ? loginUser?.city_id
                                : location.state?.city || 0
                          });
                        }}
                        variant="contained"
                      >
                        clear
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Card>
              {/* </Grid> */}
              {step == 0 &&
                (boardLoading ? (
                  <CustomLoader />
                ) : (
                  <Board
                    className="taskList"
                    data={leadList}
                    style={{ position: "relative", marginTop: "15px" }}
                    cardDragClass="kanban-drag-card"
                    components={{
                      LaneHeader: (props) => (
                        <CustomLaneHeader
                          {...props}
                          setLeadStatusData={setLeadStatusData}
                          setLeadStatusDescriptionViewModal={setLeadStatusDescriptionViewModal}
                        />
                      ),
                      Card: CustomCard
                    }}
                    onCardClick={
                      async (cardId, metadata, phase) => {
                        setValue("1");
                        setMyModal({
                          mval: true,
                          lead_id: cardId,
                          l_phase: phase
                        });
                        setLeadHistory(await featchleadhistory(cardId));
                        setExpanded(0);
                      }
                      // alert(`Card with id:${cardId} clicked. Has metadata.id: ${metadata.id}`)
                    }
                    handleDragEnd={async (id, sourceLaneId, targetLaneId, _, card) => {
                      if (targetLaneId == 6 && sourceLaneId != 6 && (loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 1))) {
                        setInvoiceAmountVerifiedData({
                          lead_id: id,
                          divValue: targetLaneId,
                          from_l_phase: sourceLaneId,
                          l_allocated_to: card?.l_allocated_to,
                          showExpiry: true,
                          payment_mode: card?.payment_mode,
                          i_amount: card?.invoice_amt,
                          base_i_amount: card?.base_i_amount,
                          payment_date: card?.payment_date,
                          i_item_id: card?.i_item_id,
                          invoice_expiry_date: card?.invoice_expiry_date,
                          joining_date: card?.joining_date,
                          due_date: card?.Due_date || card?.due_date,
                          previous_due_date: card?.previous_due_date,
                          is_renewal: card?.l_type == 2,
                          membership_expiry_date: card?.l_type == 2 ? card?.expireDate : null
                        });
                        toggleInvoiceAmountVerifiedModal();
                      } else {
                        await leadStatusChange(id, targetLaneId, sourceLaneId);
                      }
                    }}
                    onLaneScroll={(requestedPage, laneId) => handleCustomLaneScroll(laneId, false)}
                  />
                ))}
              {step == 3 && newleadData && (
                <>
                  {/* <Button
                    onClick={() => {
                      setStep(0);
                    }}
                    style={{ marginBottom: "15px" }}  
                    variant="contained"
                  >
                    Back
                  </Button> */}
                  <Button className="btn btn-export">
                    <CSVLink
                      data={newleadData}
                      headers={expo_columns}
                      filename={"LeadData.csv"}
                      className="btn btn-primary test"
                      target="_blank"
                    >
                      Export CSV
                    </CSVLink>
                  </Button>
                  <DataTable
                    title="Lead List"
                    filter
                    pagination
                    highlightOnHover
                    columns={columns}
                    data={newleadData}
                  />
                </>
              )}
            </>
          )}
        </Container>
      </Page>

      {invoiceAmountVerifiedModal && (
        <InvoiceAmountVerifiedModal
          modal={invoiceAmountVerifiedModal}
          toggleModal={toggleInvoiceAmountVerifiedModal}
          onClose={handleInvoiceModalClose}
          data={invoiceAmountVerifiedData}
          setData={setInvoiceAmountVerifiedData}
          loginUser={loginUser}
        />
      )}

      {leadStatusDescriptionViewModal && (
        <LeadStatusDescriptionViewModal
          leadStatusData={leadStatusData}
          leadStatusDescriptionViewModal={leadStatusDescriptionViewModal}
          setLeadStatusDescriptionViewModal={setLeadStatusDescriptionViewModal}
        />
      )}

      {generateInvoiceModal && (
        <Modal
          open={generateInvoiceModal}
          onClose={() => {
            setGenerateInvoiceModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <InvoiceDownloadForm
            setGenerateInvoiceModal={setGenerateInvoiceModal}
            generateInvoiceModal={generateInvoiceModal}
            leadDetails={leadHistory?.leaddetails}
            type={"lead"}
            setLeadHistory={setLeadHistory}
          />
        </Modal>
      )}
    </>
  );
}
